var _defs, _g, _path, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _path9, _g26, _path10, _path11, _g27, _path12, _g28, _g29, _path13, _path14, _path15, _path16, _path17, _g30, _g31, _g32, _g33, _g34, _g35, _path18, _path19, _path20, _g36, _g37, _g38, _path21, _path22, _path23, _g39, _g40, _g41, _path24, _g42, _g43, _g44, _g45, _g46, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g47, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 501,
    height: 490,
    viewBox: "0 0 501 490",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 501,
    height: 490,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 316.761,
    height: 137.943,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.127,358.9c4.156,9.986,17.858,40.579,22.015,50.568,3.088,3.5,35.591-1.91,54.875-9.942,13.913-5.8,161.282-61.581,212.849-83.737,14.879-6.384,27.89-10.073,26.979-19.07-40.727-13.7-70.942-14.114-75.1-24.107-4.011,1.671,17.449,6.326,2.576,12.714-51.572,22.157-164.883,86.567-179.772,84.227-58.491-9.225-57.622-12.42-64.425-10.653",
    transform: "translate(-156.127 -272.612)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.381,245.292c-12.749,8.6-1.588,54.6-1.588,54.6s162.548,96.954,176.042,106.234c-18.633-17.363-8.328-38.708-8.328-38.708l224.623-89.978-194.842-88.41Z",
    transform: "translate(-52.272 -189.026)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -0.125,
    y1: 0.848,
    x2: -0.122,
    y2: 0.848,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#004612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    stopColor: "#004912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#005512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#006912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#007412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#007012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#006412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.978,
    stopColor: "#005012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#003412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.451,
    height: 89.552,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197,390.736c.465-8.2,6.7-26.986,7.171-35.179-5.8-4.819-17.723-8.582-23.53-13.4-4.186-3.478-37.134-23.575-52.752-36.043-4.5-3.6-7.759-3.933-8.968-4.933-.059,4.066-1.073,15.612-2.2,25.74,1.208,1,4.541,3.678,9.045,7.267,15.621,12.467,45.345,36.029,49.531,39.5,5.806,4.81,15.9,12.225,21.7,17.041",
    transform: "translate(-116.717 -301.185)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.267,
    height: 22.629,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.769,364.937c-6.05,2.4-16.423,4.038-28.714,5.081-30.989,2.64-71.756,4.955-88.537,3.018,1.692.8.977-1.861,2.668-1.123,3.029,1.313,6.045,2.535,9.019,3.666,24.333,9.268,10.6,11.988,10.6,11.988,8.221-.381,51.434-.191,59.654-.57,10-.461,24.908-2.914,34.915-3.379,0,0,2.977-1.927,4.963-7.689,1.11-3.215.387-7-4.564-10.991",
    transform: "translate(-38.518 -364.937)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.498,
    height: 27.477,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.772,384.92c.414,7.478-17.937,14.579-40.991,15.862S5.7,397.042,5.287,389.563s17.937-14.575,40.989-15.857,42.081,3.737,42.5,11.214",
    transform: "translate(-5.28 -373.505)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 0.5,
    cy: 0.5,
    r: 1.179,
    gradientTransform: "matrix(0.399, 0, 0, -0.302, -0.035, 1.985)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#535353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#6c6c6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 207.281,
    height: 144.358,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.694,292.655c-5.743,6.834-32.768,6.723-38.513,13.553,19.085,7.608,45.293,31.9,56.405,41.266,8.026,6.752,70.172,59.846,100.363,84.6,8.705,7.15,32.4,7.816,49.773-6.71,5.752-6.83-24.137-11.783-18.385-18.621-2.314-1.948-.183,4.388-8.892-2.754-30.192-24.763-87.732-71.748-95.754-78.5-11.117-9.359-33.88-23.477-45-32.838",
    transform: "translate(-2.181 -292.655)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.208,365.693q-8.9,10.343-17.814,20.678,21.5,18.556,43.008,37.119c8.572.082,19.387-3.833,25.327-10.719,5.518-6.414,13.26-20.3,9.052-29.184q-21.506-18.557-43.008-37.118-8.282,9.613-16.566,19.224",
    transform: "translate(-127.394 -346.469)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.108,340.51l25.74,5.951L54.087,365.54l38.3-14.985-14.9-21.781Z",
    transform: "translate(-36.108 -328.774)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: -0.553,
    y1: 1.875,
    x2: -0.536,
    y2: 1.875,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#a76b0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#d0ae3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ead859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#f4e865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#b68d30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#7e3b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e3b00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.351,308.758l21.893,14.723,34.1-26.222-26.111,4,.159-20.6Z",
    transform: "translate(-91.351 -280.658)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: -1.499,
    y1: 2.444,
    x2: -1.481,
    y2: 2.444,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.774,382.85c-.935,21.615,22.728,26.939,30.838,26.358,11.939-.861,22.179-7.219,26.445-26.5a24.382,24.382,0,0,0-6.831-23.022c-12.61-9.237-22.088-12.886-29.21-12.886-17.013,0-20.579,20.826-21.242,36.055",
    transform: "translate(-135.747 -346.795)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: -1.662,
    y1: 1.056,
    x2: -1.649,
    y2: 1.056,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6f6f6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#757574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347,
    stopColor: "#868685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#a2a2a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9d9d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.036,399.632s13.075,11.572,25.376-.848c13.851-13.98,2.372-21.834,1.18-23.977-7.346-5.93-30.269-23.84-30.269-23.84s-8.115,37.438,3.714,48.664",
    transform: "translate(-139.607 -350.968)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: -1.845,
    y1: 1.079,
    x2: -1.83,
    y2: 1.079,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c9b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.346,272.531a26.309,26.309,0,0,0-6.271,24.545L166.627,415.2s-11.763-18.7,1.266-38.445,36.362-3.965,40-.4C201.351,367.27,76.546,280.445,69.58,274.59,64.844,270.6,56.814,265,48.109,265c-5.2,0-10.638,2-15.763,7.535",
    transform: "translate(-25.243 -264.996)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: -0.01,
    y1: 0.926,
    x2: -0.005,
    y2: 0.926,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c9b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#9c9b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#9e9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807,
    stopColor: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ececec"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.964,302.273c22.4,24.666,129.477,108.65,135.3,112.976-16.8-21.737,4.236-51.5,4.236-51.5S58.986,288.088,35.406,267.122c-16.82,7.61-13.48,28.5-7.443,35.151",
    transform: "translate(-23.043 -267.122)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 0.035,
    y1: 0.981,
    x2: 0.04,
    y2: 0.981,
    xlinkHref: "#aa"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.246,322.585c-2.4,14.946,1.591,18.226,3.419,20.672.784,1.042,15.531,14.279,22.374,15.782-2.408-5.547-2.732-13.915-1.817-20.706,2.174-16.125,19.4-30.738,33.82-25.524-2.908-4.575-18.574-17.469-25.422-18.891a19.047,19.047,0,0,0-3.872-.4c-13.166,0-25.981,13.367-28.5,29.062",
    transform: "translate(-64.5 -293.523)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: -0.678,
    y1: 1.754,
    x2: -0.664,
    y2: 1.754,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#9c5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#a06005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#ae7614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395,
    stopColor: "#c3992d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#e1c94f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    stopColor: "#f9f06b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673,
    stopColor: "#eedf5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#d4b541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947,
    stopColor: "#aa7010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c5900"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.72,322.31c-26.825,11.032-7.668,50.945-24.644,53.19-17.112,2.271-24.056,5.9-24.056,5.9-.059,1.723,5.368,1.189,6.443,1.677,1.413.635-1.046,3.838.315,3.383,3.423-1.057,7.4-1.054,11.875-1.05,5.5,0,11.756.009,18.639-1.968,12.474-3.579,6.989-16.759,12.413-36.283s41.706-11.257,52.982-1.111c-.327-1.829-19.982-26.01-42.465-26.01a29.968,29.968,0,0,0-11.5,2.272",
    transform: "translate(-72.019 -320.038)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: -0.692,
    y1: 1.142,
    x2: -0.681,
    y2: 1.142,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#860000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#860000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#c70000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#860000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.995,376.216c-.054-.97,4.136-3.592,12.146-4.033s12.467,1.69,12.52,2.662-4.134,3.589-12.146,4.037q-1.11.06-2.129.059c-6.667,0-10.343-1.842-10.392-2.725m11.97-7.21c-7.7.429-15.381,3.107-15.141,7.387s8.161,6.092,15.867,5.664,15.381-3.105,15.145-7.389c-.216-3.873-6.719-5.725-13.664-5.725-.733,0-1.472.021-2.207.061",
    transform: "translate(-55.818 -368.944)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: -1.881,
    y1: 2.556,
    x2: -1.846,
    y2: 2.556,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#9c5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#aa7010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#d4b541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897,
    stopColor: "#eedf5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#f9f06b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9f06b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.945,375.2c-.053-.97,4.136-3.589,12.147-4.035s12.467,1.694,12.521,2.667-4.136,3.592-12.15,4.038q-1.108.06-2.123.06c-6.671,0-10.347-1.846-10.4-2.731m12.018-6.388c-7.706.428-15.427,2.287-15.19,6.568s8.164,6.1,15.867,5.667,15.383-3.105,15.145-7.392c-.2-3.69-6.082-4.933-12.636-4.933-1.051,0-2.121.032-3.186.091",
    transform: "translate(-55.767 -368.717)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: -1.894,
    y1: 2.567,
    x2: -1.859,
    y2: 2.567,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f06b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#f9f06b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#eedf5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292,
    stopColor: "#d4b541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#aa7010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#9c5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c5900"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.273,369.749c-17.4.965-31.894,5.979-36.563,12.037l-1.816.1.241,4.319c.437,7.9,18.225,13.331,39.724,12.134S84.437,389.777,84,381.878l-.24-4.324-1.816.105c-4.7-4.872-16.962-8.075-31.781-8.075q-2.885,0-5.888.165",
    transform: "translate(-5.894 -369.584)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: -0.077,
    y1: 1.624,
    x2: -0.063,
    y2: 1.624,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#854c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#854c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#8a5303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#97680e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ae8b20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#cdbb38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#ded445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#d3c33c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#b89a27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#8c5705"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864e01"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.033,366.087c-21.5,1.2-38.577,8.569-38.138,16.464s18.226,13.328,39.726,12.132S84.2,386.117,83.76,378.217c-.4-7.161-15.072-12.295-33.846-12.295-1.92,0-3.885.054-5.88.165",
    transform: "translate(-5.887 -365.922)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: -0.113,
    y1: 1.044,
    x2: -0.098,
    y2: 1.044,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#9e5c02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    stopColor: "#c49b2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#e1c94f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#f2e563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    stopColor: "#f9f06b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673,
    stopColor: "#eedf5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#d4b541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947,
    stopColor: "#aa7010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c5900"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.134,368.216c-17.715.986-31.809,6.625-31.477,12.6s14.964,10.02,32.679,9.035,31.809-6.627,31.478-12.6c-.3-5.37-12.155-9.177-27.417-9.177-1.715,0-3.473.048-5.263.148",
    transform: "translate(-11.652 -368.068)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: -0.262,
    y1: 1.191,
    x2: -0.242,
    y2: 1.191,
    xlinkHref: "#ap"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "au"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.134,368.216c-17.715.986-31.809,6.625-31.477,12.6a3.758,3.758,0,0,0,.169.9c1.055-5.624,14.595-10.756,31.409-11.687s30.838,2.659,32.508,8.133a3.932,3.932,0,0,0,.071-.912c-.3-5.369-12.156-9.177-27.417-9.177q-2.574,0-5.263.148",
    transform: "translate(-11.652 -368.068)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: -0.2,
    y1: 3.217,
    x2: -0.182,
    y2: 3.217,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.013,
    stopColor: "#9e5c02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257,
    stopColor: "#c49b2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#e1c94f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopColor: "#f2e563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#f9f06b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    stopColor: "#eedf5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "#d4b541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#aa7010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#9c5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c5900"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ax"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.977,333.515c-26.827,11.03-18.64,35.651-37.659,41.006-13.825,3.9-29.306,4.552-29.306,4.552-.159,1.154.974,2.787,1.831,3.6.454.433-1.608,1.411-.708,1.524,6.17.52,25.933,3.488,38.766,1.559,12.211-1.839,16.4-4.487,25.064-22.8,10.983-23.224,39.765-17.256,45.4-12.68-.312-1.764-11.361-19.5-30.262-19.5a34.358,34.358,0,0,0-13.128,2.745",
    transform: "translate(-71.996 -330.77)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: -0.763,
    y1: 1.077,
    x2: -0.753,
    y2: 1.077,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    stopColor: "#b10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#c60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#e90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#f70000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#e20000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.926,
    stopColor: "#bf0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 242.903,
    height: 131.737,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.251,247.716c-6.147,8.331-76.827,67.494-92.095,75.227-38.493,19.5-125.157-5.119-148.437-2.626,2.781,1.182,48.9,21.642,51.634,22.681,4.9,1.867,20.659,18.244,25.353,19.694,23.883,9.767,28,16.76,28,16.76,10.65-4.321,33-13.658,43.445-18.058,12.711-5.36,19.681-9.944,32.392-15.3,0,0,36.931-51.606,43.19-64.947,4.928-10.505,25.855-25.966,16.512-33.427",
    transform: "translate(-150.719 -247.716)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.6,290.733,298.4,330.947s11,15.38-1.3,31.564c9.35-9.128,113.875-109.934,113.875-109.934A9.6,9.6,0,0,0,412,251.225c4.351-7.234,9.941-27.092-1.018-30.213l-160.2-26.267Z",
    transform: "translate(-109.596 -194.746)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: -0.336,
    y1: 1.022,
    x2: -0.332,
    y2: 1.022,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00034c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565,
    stopColor: "#00034c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#03064f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#0c105b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#1c206f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#32378a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919,
    stopColor: "#363b8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#33388b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#2c317f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    stopColor: "#20246b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#0f1350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957,
    stopColor: "#000336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000336"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bf"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193.383,
    height: 72.76,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195.27,
    height: 73.106,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bh"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248.729,
    height: 159.499,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.127,296.227c9.037,7.594,62.7,73.965,71.736,81.561,13.776-7.6,31.65-30.425,45.415-38.039,9.951-5.485,73.873-34.8,109.381-57.3,36.52-23.153,19.779-53.261,7.382-63.805-4.73-3.433-12.295,19.713-32.169,5.193-2.87,1.578-10.666,6.019-21.188,12.042C293.2,256.759,223.95,296.62,214.014,302.1c-13.771,7.612-51.113-13.489-64.887-5.876",
    transform: "translate(-149.127 -218.29)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.573,91.912s62.236,44.521,85.852,0L270.437,49.1Z",
    transform: "translate(-270.437 -49.098)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: -3.711,
    y1: 4.945,
    x2: -3.698,
    y2: 4.945,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#063"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.126,227.44s68.042,45.253,87.95,56.434,35.576-7.906,35.576-7.906v-185c-6.383,7.985-30.909,9.024-35.576,6.628s-87.95-44.614-87.95-44.614Z",
    transform: "translate(-239.126 -52.983)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: -2.284,
    y1: 1.766,
    x2: -2.275,
    y2: 1.766,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#036933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0d7533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#1e8934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#35a434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#39a935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39a935"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bp"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123.526,
    height: 60.123,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bq"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123.526,
    height: 62.021,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "br"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.918,242.043s68.04,45.257,87.95,56.436,35.574-7.9,35.574-7.9v-185c-6.382,7.985-30.91,9.024-35.574,6.629s-87.95-44.616-87.95-44.616Z",
    transform: "translate(-209.918 -67.588)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: -2.005,
    y1: 1.694,
    x2: -1.996,
    y2: 1.694,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#925f36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#925f36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#925f36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812,
    stopColor: "#c99d66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b17f49"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bu"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123.524,
    height: 60.123,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bv"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123.524,
    height: 62.022,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.351,274.035s64.775,48.175,83.983,60.293,37.761-5.074,37.761-5.074,18.812-146.123,22.832-177.35c-7.587,7.206-33.076,6.473-37.6,3.849s-85.441-48.961-85.441-48.961Z",
    transform: "translate(-161.351 -106.793)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    x1: -0.777,
    y1: 1.442,
    x2: -0.771,
    y2: 1.442,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c78726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#c78726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812,
    stopColor: "#fced3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8b133"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bz"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124.82,
    height: 64.599,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ca"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.81,
    height: 66.419,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.922,129.222l5.906,156.067L242.055,350.2l24.832-175.42s-53.469-30.942-82.51-47.49a62.48,62.48,0,0,0-20.691-3.968c-13.175,0-18.764,5.9-18.764,5.9",
    transform: "translate(-144.922 -123.326)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    x1: -0.459,
    y1: 2.006,
    x2: -0.454,
    y2: 2.006,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01b8bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.049,
    stopColor: "#01b8bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#087d75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087d75"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.921,295.641l91.778,59.5,24.953-173.093-94.309-53.73Z",
    transform: "translate(-125.921 -128.318)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf",
    x1: -1.273,
    y1: 1.492,
    x2: -1.263,
    y2: 1.492,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#087d75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#087d75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01a197"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ch"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.623,
    height: 65.113,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ci"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.66,
    height: 60.814,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cj"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190.778,
    height: 54.023,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ck"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.985,109.954c-7.435,24.994-.871,28.762,6.713,33.368,17.076,5.745,56.332,21.264,88.055,20.637,29.5-.586,60.927-15.286,84.819-22.437,11.773-6.054,7.466-18.383,5.588-24.508-2.587-3.627-9.237,15.493-89.972,27.282-64.9,9.48-88.775-24.174-95.2-34.343",
    transform: "translate(-161.72 -109.954)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.421,54.876l-71.08,1.956-58.395,1.607c-3.26.091-8.053.221-12.86.354l-13.168.363c.963,35.031-3.39,30.6-5.3,66.212,1.48,12.692,7.107,13.61,11.869,16.989,6.985,4.952,19.589,9.793,24.7,11.15,32.791,8.708,54.391,8.469,56.049,8.416.158,0,.5.009,1.005.021,5.685.138,32.986.278,77.14-23.474,4.357-2.344,14.276-10.175,14.682-16.629-.964-35.031-9.658-32.322-10.619-67.353-2.7.076-11.321.312-14.017.386",
    transform: "translate(-164.613 -54.49)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cm"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 185.443,
    height: 107.734,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "co"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.6,52.93a2.984,2.984,0,0,0-1.8.735,3.427,3.427,0,0,0-.455.667,1.612,1.612,0,0,0-.126,1.055,1.056,1.056,0,0,0,1.073.751,1.766,1.766,0,0,0,1.26-.543c.327-.413.473-.883.779-1.3a2.234,2.234,0,0,1,1.077-.778,2.074,2.074,0,0,0-1.554-.6q-.127,0-.255.011",
    transform: "translate(-240.187 -52.919)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cp"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.293,
    height: 3.254,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.106,53.241a3,3,0,0,0-1.9.748,6.985,6.985,0,0,0-.638.991,2.135,2.135,0,0,1-.627.828,2.182,2.182,0,0,0,1.826.646,1.709,1.709,0,0,0,1.153-.535c.312-.4.46-.85.739-1.252a2.224,2.224,0,0,1,1.116-.837,2.026,2.026,0,0,0-1.53-.591l-.133,0",
    transform: "translate(-241.936 -53.239)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cr"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.833,
    height: 3.28,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.379,53.556a2.972,2.972,0,0,0-1.912.755,7.328,7.328,0,0,0-.66,1.029,2.045,2.045,0,0,1-.609.791,2.117,2.117,0,0,0,1.817.64,1.715,1.715,0,0,0,1.132-.536c.3-.384.451-.818.716-1.212A2.23,2.23,0,0,1,249,54.14a1.964,1.964,0,0,0-1.5-.588q-.062,0-.124,0",
    transform: "translate(-244.199 -53.552)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ct"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.805,
    height: 3.289,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.563,53.867a2.96,2.96,0,0,0-1.854.756,7.078,7.078,0,0,0-.641,1,2.152,2.152,0,0,1-.631.824,2.059,2.059,0,0,0,1.75.644,1.749,1.749,0,0,0,1.167-.548c.315-.4.473-.846.753-1.248a2.264,2.264,0,0,1,1.115-.852,1.921,1.921,0,0,0-1.481-.582c-.059,0-.119,0-.178.006",
    transform: "translate(-246.437 -53.861)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cv"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.785,
    height: 3.289,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.849,54.164a3,3,0,0,0-1.914.767,7.359,7.359,0,0,0-.65,1,2.225,2.225,0,0,1-.636.829,2.015,2.015,0,0,0,1.782.628,1.74,1.74,0,0,0,1.116-.543c.317-.4.478-.849.766-1.252a2.264,2.264,0,0,1,1.118-.85,1.905,1.905,0,0,0-1.473-.582l-.109,0",
    transform: "translate(-248.649 -54.162)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cx"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.782,
    height: 3.305,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.027,54.463a3.013,3.013,0,0,0-1.882.769,7.3,7.3,0,0,0-.66,1.009,2.335,2.335,0,0,1-.641.826,1.959,1.959,0,0,0,1.736.626,1.757,1.757,0,0,0,1.142-.549c.324-.4.492-.846.776-1.246a2.342,2.342,0,0,1,1.129-.862,1.854,1.854,0,0,0-1.446-.576c-.052,0-.1,0-.156,0",
    transform: "translate(-250.844 -54.458)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cz"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.784,
    height: 3.306,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "da"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.161,54.757a3.052,3.052,0,0,0-1.821.77,7.672,7.672,0,0,0-.662,1,2.334,2.334,0,0,1-.655.837,1.909,1.909,0,0,0,1.667.627,1.833,1.833,0,0,0,1.208-.559c.329-.4.5-.855.794-1.26a2.4,2.4,0,0,1,1.133-.854,1.842,1.842,0,0,0-1.435-.569c-.076,0-.153,0-.23.009",
    transform: "translate(-253.023 -54.748)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "db"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.803,
    height: 3.299,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.385,55.042a3.033,3.033,0,0,0-1.85.774,7.566,7.566,0,0,0-.67.986,2.464,2.464,0,0,1-.671.853,2.021,2.021,0,0,0,2.871.057c.339-.405.514-.862.821-1.273a2.429,2.429,0,0,1,1.13-.839,1.813,1.813,0,0,0-1.414-.566c-.072,0-.145,0-.217.008",
    transform: "translate(-255.193 -55.034)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.823,
    height: 3.301,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "de"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.581,55.321a3.1,3.1,0,0,0-1.861.777,8.5,8.5,0,0,0-.678.985,2.467,2.467,0,0,1-.688.852,1.856,1.856,0,0,0,1.671.614,1.9,1.9,0,0,0,1.2-.56c.347-.406.531-.863.841-1.273a2.476,2.476,0,0,1,1.145-.842,1.8,1.8,0,0,0-1.41-.561c-.073,0-.149,0-.223.008",
    transform: "translate(-257.354 -55.313)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "df"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.861,
    height: 3.303,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.622,55.612a3.117,3.117,0,0,0-1.711.764,8.213,8.213,0,0,0-.7.989,2.569,2.569,0,0,1-.7.85,1.829,1.829,0,0,0,1.539.618,1.993,1.993,0,0,0,1.346-.574c.349-.405.543-.861.858-1.268a2.525,2.525,0,0,1,1.158-.842,1.784,1.784,0,0,0-1.405-.561,3.074,3.074,0,0,0-.388.025",
    transform: "translate(-259.515 -55.587)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dh"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.901,
    height: 3.276,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "di"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.812,55.88a3.163,3.163,0,0,0-1.728.765,8.3,8.3,0,0,0-.714.989,2.553,2.553,0,0,1-.709.848,1.809,1.809,0,0,0,1.538.615,2.067,2.067,0,0,0,1.362-.576c.356-.405.555-.856.877-1.266a2.6,2.6,0,0,1,1.172-.843,1.787,1.787,0,0,0-1.407-.557,2.919,2.919,0,0,0-.391.026",
    transform: "translate(-261.661 -55.854)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dj"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.948,
    height: 3.276,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.01,56.146a3.232,3.232,0,0,0-1.749.765,9.2,9.2,0,0,0-.727.985,2.6,2.6,0,0,1-.723.849,1.786,1.786,0,0,0,1.539.608,2.092,2.092,0,0,0,1.379-.574c.366-.4.573-.855.9-1.263a2.627,2.627,0,0,1,1.186-.843,1.8,1.8,0,0,0-1.408-.554,3.241,3.241,0,0,0-.4.026",
    transform: "translate(-263.811 -56.12)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dl"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.005,
    height: 3.269,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.223,56.4a3.313,3.313,0,0,0-1.768.771,8.233,8.233,0,0,0-.739.984,2.718,2.718,0,0,1-.742.847,1.806,1.806,0,0,0,1.546.606,2.189,2.189,0,0,0,1.4-.575c.371-.4.582-.856.915-1.263a2.692,2.692,0,0,1,1.2-.841,1.805,1.805,0,0,0-1.416-.555,3.28,3.28,0,0,0-.4.026",
    transform: "translate(-265.974 -56.379)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dn"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.065,
    height: 3.267,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "do"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.451,56.669a3.387,3.387,0,0,0-1.787.762,9.742,9.742,0,0,0-.755.985,2.723,2.723,0,0,1-.752.846,1.8,1.8,0,0,0,1.548.6,2.218,2.218,0,0,0,1.424-.57c.381-.4.594-.854.937-1.26a2.682,2.682,0,0,1,1.223-.837,1.84,1.84,0,0,0-1.43-.553,3.19,3.19,0,0,0-.408.027",
    transform: "translate(-268.157 -56.642)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dp"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.132,
    height: 3.257,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.7,56.929a3.464,3.464,0,0,0-1.809.762,9.018,9.018,0,0,0-.765.979,2.838,2.838,0,0,1-.773.846,1.834,1.834,0,0,0,1.564.6,2.314,2.314,0,0,0,1.447-.57c.388-.4.609-.848.953-1.253a2.769,2.769,0,0,1,1.239-.837,1.857,1.857,0,0,0-1.446-.553,3.454,3.454,0,0,0-.411.026",
    transform: "translate(-270.355 -56.903)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dr"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.203,
    height: 3.248,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ds"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.98,57.191a3.536,3.536,0,0,0-1.834.759,9.623,9.623,0,0,0-.781.977,2.707,2.707,0,0,1-.785.841,1.846,1.846,0,0,0,1.58.6,2.361,2.361,0,0,0,1.466-.569c.4-.4.624-.846.972-1.248a2.807,2.807,0,0,1,1.258-.836,1.9,1.9,0,0,0-1.461-.552,3.533,3.533,0,0,0-.415.026",
    transform: "translate(-272.58 -57.165)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dt"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.276,
    height: 3.241,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "du"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.278,62.38a2.977,2.977,0,0,0-1.8.735,3.521,3.521,0,0,0-.458.668,1.617,1.617,0,0,0-.125,1.052,1.059,1.059,0,0,0,1.072.751,1.762,1.762,0,0,0,1.259-.542c.328-.415.473-.886.782-1.3a2.21,2.21,0,0,1,1.076-.777,2.069,2.069,0,0,0-1.552-.6c-.085,0-.171,0-.257.011",
    transform: "translate(-309.862 -62.369)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dv"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.293,
    height: 3.253,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.779,62.69a2.991,2.991,0,0,0-1.9.749,6.925,6.925,0,0,0-.637.99,2.091,2.091,0,0,1-.627.827,2.183,2.183,0,0,0,1.824.648,1.716,1.716,0,0,0,1.154-.536c.311-.4.457-.849.736-1.252a2.225,2.225,0,0,1,1.118-.836,2.021,2.021,0,0,0-1.531-.592l-.133,0",
    transform: "translate(-311.611 -62.688)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dx"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.832,
    height: 3.28,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.054,63a2.971,2.971,0,0,0-1.913.756,7.315,7.315,0,0,0-.661,1.029,2.014,2.014,0,0,1-.608.79,2.118,2.118,0,0,0,1.817.641,1.718,1.718,0,0,0,1.133-.536c.3-.385.452-.818.715-1.211a2.221,2.221,0,0,1,1.139-.883,1.968,1.968,0,0,0-1.5-.588c-.04,0-.081,0-.122,0",
    transform: "translate(-313.873 -63.002)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dz"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.804,
    height: 3.289,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.237,63.316a2.972,2.972,0,0,0-1.853.756,7.476,7.476,0,0,0-.644,1,2.155,2.155,0,0,1-.628.826,2.06,2.06,0,0,0,1.748.642,1.741,1.741,0,0,0,1.167-.548c.316-.4.473-.844.755-1.248a2.253,2.253,0,0,1,1.115-.85,1.921,1.921,0,0,0-1.48-.583c-.06,0-.12,0-.181.006",
    transform: "translate(-316.112 -63.31)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eb"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.785,
    height: 3.288,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.524,63.615a2.969,2.969,0,0,0-1.913.765,6.878,6.878,0,0,0-.65,1,2.283,2.283,0,0,1-.636.829,2.013,2.013,0,0,0,1.778.628,1.735,1.735,0,0,0,1.116-.544c.32-.4.483-.848.767-1.252a2.279,2.279,0,0,1,1.116-.852,1.889,1.889,0,0,0-1.461-.579c-.039,0-.078,0-.118,0",
    transform: "translate(-318.325 -63.613)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ed"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.778,
    height: 3.303,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.7,63.912a3.008,3.008,0,0,0-1.882.77,7.471,7.471,0,0,0-.66,1.006,2.3,2.3,0,0,1-.642.827,1.971,1.971,0,0,0,1.738.627,1.775,1.775,0,0,0,1.142-.55c.323-.4.492-.846.775-1.246a2.341,2.341,0,0,1,1.131-.862,1.866,1.866,0,0,0-1.451-.575c-.05,0-.1,0-.151,0",
    transform: "translate(-320.517 -63.908)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ef"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.786,
    height: 3.303,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.833,64.207a3.023,3.023,0,0,0-1.817.768,7.934,7.934,0,0,0-.666,1,2.334,2.334,0,0,1-.651.837,1.909,1.909,0,0,0,1.665.628,1.858,1.858,0,0,0,1.208-.559c.328-.4.5-.854.793-1.261a2.42,2.42,0,0,1,1.134-.852,1.838,1.838,0,0,0-1.433-.57c-.077,0-.155,0-.234.009",
    transform: "translate(-322.699 -64.198)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eh"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.8,
    height: 3.297,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ei"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.058,64.491a3.05,3.05,0,0,0-1.849.774,7.685,7.685,0,0,0-.67.986,2.486,2.486,0,0,1-.67.854,2.018,2.018,0,0,0,2.869.057c.339-.406.514-.863.821-1.274a2.416,2.416,0,0,1,1.132-.836,1.808,1.808,0,0,0-1.415-.568c-.072,0-.144,0-.217.008",
    transform: "translate(-324.868 -64.483)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ej"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.822,
    height: 3.302,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ek"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.255,64.771a3.1,3.1,0,0,0-1.86.776,7.955,7.955,0,0,0-.679.986,2.539,2.539,0,0,1-.688.853A1.856,1.856,0,0,0,328.7,68a1.9,1.9,0,0,0,1.2-.562c.347-.406.529-.861.843-1.272a2.455,2.455,0,0,1,1.145-.84,1.8,1.8,0,0,0-1.414-.563c-.073,0-.147,0-.221.009",
    transform: "translate(-327.029 -64.762)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.3,65.061a3.1,3.1,0,0,0-1.712.765,7.958,7.958,0,0,0-.7.986,2.537,2.537,0,0,1-.7.852,1.82,1.82,0,0,0,1.539.618,2,2,0,0,0,1.346-.574c.35-.4.542-.859.858-1.268a2.547,2.547,0,0,1,1.159-.843,1.8,1.8,0,0,0-1.411-.561,2.986,2.986,0,0,0-.382.026",
    transform: "translate(-329.189 -65.035)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "en"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.902,
    height: 3.279,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.7,99.778c-.441.267-.925.364-1.368.651a1.767,1.767,0,0,0-.663,1.2,1.064,1.064,0,0,0,.645,1.141,1.623,1.623,0,0,0,1.057-.024,3.476,3.476,0,0,0,.712-.393,2.969,2.969,0,0,0,.9-1.72,2.168,2.168,0,0,0-.407-1.857,2.19,2.19,0,0,1-.877,1",
    transform: "translate(-331.653 -98.781)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ep"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.526,
    height: 4.157,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.544,97.527c-.43.241-.891.344-1.317.615a1.724,1.724,0,0,0-.645,1.1,2.2,2.2,0,0,0,.468,1.879,2.106,2.106,0,0,1,.885-.542,7.007,7.007,0,0,0,1.047-.543,2.976,2.976,0,0,0,.924-1.824,2.07,2.07,0,0,0-.424-1.715,2.22,2.22,0,0,1-.938,1.032",
    transform: "translate(-331.534 -96.495)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "er"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.535,
    height: 4.624,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "es"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.4,95.288c-.414.226-.863.335-1.274.6a1.731,1.731,0,0,0-.643,1.076,2.133,2.133,0,0,0,.464,1.871,2.063,2.063,0,0,1,.846-.529,7.168,7.168,0,0,0,1.087-.56,2.993,2.993,0,0,0,.936-1.832,2.018,2.018,0,0,0-.428-1.674,2.219,2.219,0,0,1-.987,1.05",
    transform: "translate(-331.433 -94.238)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "et"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.543,
    height: 4.594,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.348,93.025c-.427.242-.887.354-1.313.632a1.77,1.77,0,0,0-.66,1.11,2.072,2.072,0,0,0,.474,1.8,2.156,2.156,0,0,1,.881-.547,7.174,7.174,0,0,0,1.055-.542,2.981,2.981,0,0,0,.931-1.774A2,2,0,0,0,334.3,92a2.259,2.259,0,0,1-.955,1.028",
    transform: "translate(-331.334 -91.997)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ev"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.552,
    height: 4.572,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ew"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.263,90.8c-.428.247-.891.364-1.316.644A1.733,1.733,0,0,0,331.3,92.5a2.023,2.023,0,0,0,.454,1.834,2.245,2.245,0,0,1,.886-.553,7.29,7.29,0,0,0,1.058-.55,3.007,3.007,0,0,0,.948-1.834,1.947,1.947,0,0,0-.427-1.631,2.239,2.239,0,0,1-.952,1.032",
    transform: "translate(-331.24 -89.769)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ex"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.56,
    height: 4.568,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ey"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.174,88.6c-.425.244-.886.368-1.312.653a1.762,1.762,0,0,0-.658,1.084,1.966,1.966,0,0,0,.457,1.792,2.306,2.306,0,0,1,.883-.56,7.385,7.385,0,0,0,1.066-.56,3.014,3.014,0,0,0,.946-1.8,1.927,1.927,0,0,0-.413-1.651,2.356,2.356,0,0,1-.968,1.043",
    transform: "translate(-331.151 -87.554)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ez"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.571,
    height: 4.572,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.109,86.388c-.428.259-.9.383-1.325.67a1.838,1.838,0,0,0-.673,1.15,1.913,1.913,0,0,0,.461,1.722,2.361,2.361,0,0,1,.9-.57,8.034,8.034,0,0,0,1.057-.566,3.046,3.046,0,0,0,.939-1.737,1.937,1.937,0,0,0-.4-1.715,2.346,2.346,0,0,1-.958,1.046",
    transform: "translate(-331.069 -85.342)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fb"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.58,
    height: 4.588,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.058,84.186c-.439.265-.911.4-1.348.7a2.025,2.025,0,0,0-.218,2.864,2.5,2.5,0,0,1,.911-.587,7.438,7.438,0,0,0,1.044-.572,3.038,3.038,0,0,0,.949-1.769,1.909,1.909,0,0,0-.4-1.679,2.424,2.424,0,0,1-.94,1.048",
    transform: "translate(-330.993 -83.138)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.581,
    height: 4.607,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.991,81.988c-.438.272-.909.41-1.346.716a1.9,1.9,0,0,0-.673,1.146,1.861,1.861,0,0,0,.448,1.723,2.519,2.519,0,0,1,.913-.6,7.644,7.644,0,0,0,1.047-.582,3.1,3.1,0,0,0,.951-1.777,1.9,1.9,0,0,0-.393-1.681,2.466,2.466,0,0,1-.948,1.059",
    transform: "translate(-330.922 -80.929)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.592,
    height: 4.644,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.929,79.79c-.437.276-.907.423-1.344.731a2.027,2.027,0,0,0-.7,1.287,1.814,1.814,0,0,0,.469,1.591,2.525,2.525,0,0,1,.913-.614,8.136,8.136,0,0,0,1.049-.6,3.126,3.126,0,0,0,.925-1.632,1.975,1.975,0,0,0-.364-1.838,2.531,2.531,0,0,1-.948,1.072",
    transform: "translate(-330.858 -78.718)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fh"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.59,
    height: 4.682,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.872,77.6c-.437.282-.9.436-1.342.752a2.079,2.079,0,0,0-.7,1.3,1.805,1.805,0,0,0,.465,1.589,2.585,2.585,0,0,1,.911-.624,8.585,8.585,0,0,0,1.053-.614,3.192,3.192,0,0,0,.927-1.65,1.968,1.968,0,0,0-.356-1.84,2.58,2.58,0,0,1-.953,1.084",
    transform: "translate(-330.799 -76.518)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fj"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.597,
    height: 4.728,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.824,75.4c-.439.287-.906.449-1.343.776a2.093,2.093,0,0,0-.7,1.318,1.8,1.8,0,0,0,.458,1.594,2.583,2.583,0,0,1,.913-.641,9.183,9.183,0,0,0,1.05-.631,3.245,3.245,0,0,0,.932-1.668,2,2,0,0,0-.355-1.848,2.63,2.63,0,0,1-.951,1.1",
    transform: "translate(-330.748 -74.304)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fl"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.593,
    height: 4.788,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.777,73.193c-.437.292-.906.458-1.343.788a2.2,2.2,0,0,0-.706,1.34,1.806,1.806,0,0,0,.453,1.6,2.7,2.7,0,0,1,.916-.655,8.527,8.527,0,0,0,1.047-.642,3.271,3.271,0,0,0,.936-1.688,2,2,0,0,0-.349-1.859,2.668,2.668,0,0,1-.953,1.118",
    transform: "translate(-330.699 -72.075)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fn"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.598,
    height: 4.845,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.734,70.959c-.434.3-.906.47-1.342.81a2.248,2.248,0,0,0-.706,1.365,1.8,1.8,0,0,0,.45,1.6,2.706,2.706,0,0,1,.912-.668,9.885,9.885,0,0,0,1.053-.657,3.392,3.392,0,0,0,.931-1.709,2.045,2.045,0,0,0-.345-1.883,2.71,2.71,0,0,1-.954,1.14",
    transform: "translate(-330.657 -69.819)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fp"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.594,
    height: 4.917,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.692,68.7c-.437.3-.9.481-1.338.828a2.333,2.333,0,0,0-.709,1.388,1.841,1.841,0,0,0,.45,1.616,2.838,2.838,0,0,1,.913-.689,9.093,9.093,0,0,0,1.048-.668,3.419,3.419,0,0,0,.932-1.729,2.064,2.064,0,0,0-.343-1.9,2.8,2.8,0,0,1-.952,1.154",
    transform: "translate(-330.616 -67.548)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fr"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.59,
    height: 4.985,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.654,66.419c-.438.311-.9.49-1.339.848a2.381,2.381,0,0,0-.708,1.4,1.865,1.865,0,0,0,.447,1.636,2.712,2.712,0,0,1,.913-.7,9.556,9.556,0,0,0,1.044-.686,3.512,3.512,0,0,0,.935-1.754,2.121,2.121,0,0,0-.343-1.919,2.819,2.819,0,0,1-.949,1.173",
    transform: "translate(-330.577 -65.246)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ft"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.584,
    height: 5.06,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.506,125.9c-.443.263-1.16.177-1.6.464a2.758,2.758,0,0,0-1,1.448,2.912,2.912,0,0,0,.208,1.6c.315.452,1.716.377,2.178.413a4.67,4.67,0,0,0,1.94-.191,3.691,3.691,0,0,0,.491-2.688,5.981,5.981,0,0,0-1.335-2.049,2.227,2.227,0,0,1-.877,1",
    transform: "translate(-331.866 -124.895)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fv"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.099,
    height: 4.969,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.279,123.643c-.43.241-.89.343-1.316.614a1.728,1.728,0,0,0-.644,1.1c-.123.593-.366,1.315.129,1.889.149-.22.824-.378,1.223-.552a6.723,6.723,0,0,0,1.047-.542,3,3,0,0,0,.928-1.825,2.083,2.083,0,0,0-.425-1.714,2.223,2.223,0,0,1-.94,1.032",
    transform: "translate(-332.15 -122.611)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fx"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.779,
    height: 4.632,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.119,121.4c-.414.226-.86.335-1.276.6a1.731,1.731,0,0,0-.641,1.076,2.121,2.121,0,0,0,.463,1.868,2.072,2.072,0,0,1,.845-.526,7.346,7.346,0,0,0,1.088-.56,3,3,0,0,0,.937-1.833,2.017,2.017,0,0,0-.431-1.674,2.223,2.223,0,0,1-.985,1.05",
    transform: "translate(-332.152 -120.353)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fz"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.541,
    height: 4.592,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ga"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.066,119.142c-.427.24-.886.353-1.315.628a1.778,1.778,0,0,0-.657,1.113,2.067,2.067,0,0,0,.472,1.8,2.189,2.189,0,0,1,.881-.547,7.192,7.192,0,0,0,1.056-.543,2.973,2.973,0,0,0,.931-1.774,2,2,0,0,0-.413-1.709,2.286,2.286,0,0,1-.956,1.03",
    transform: "translate(-332.052 -118.112)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gb"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.553,
    height: 4.573,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.981,116.917c-.428.246-.891.364-1.317.641a1.746,1.746,0,0,0-.65,1.062,2.024,2.024,0,0,0,.455,1.833,2.26,2.26,0,0,1,.884-.555,6.757,6.757,0,0,0,1.059-.552,2.983,2.983,0,0,0,.949-1.831,1.949,1.949,0,0,0-.425-1.632,2.258,2.258,0,0,1-.955,1.033",
    transform: "translate(-331.958 -115.884)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.56,
    height: 4.569,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ge"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.892,114.711c-.426.246-.886.371-1.311.655a1.77,1.77,0,0,0-.66,1.084,1.971,1.971,0,0,0,.457,1.79,2.288,2.288,0,0,1,.884-.559,7.347,7.347,0,0,0,1.064-.562,3.008,3.008,0,0,0,.948-1.8,1.93,1.93,0,0,0-.414-1.651,2.346,2.346,0,0,1-.968,1.042",
    transform: "translate(-331.869 -113.669)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gf"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.57,
    height: 4.572,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.83,112.5c-.432.256-.9.383-1.328.67a1.852,1.852,0,0,0-.674,1.15,1.91,1.91,0,0,0,.464,1.722,2.332,2.332,0,0,1,.9-.57,7.956,7.956,0,0,0,1.057-.566,3.042,3.042,0,0,0,.938-1.737,1.933,1.933,0,0,0-.4-1.713,2.37,2.37,0,0,1-.957,1.044",
    transform: "translate(-331.786 -111.459)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gh"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.579,
    height: 4.586,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.777,110.3c-.439.266-.911.4-1.348.7a2.023,2.023,0,0,0-.219,2.865,2.475,2.475,0,0,1,.912-.587,7.7,7.7,0,0,0,1.044-.572,3.039,3.039,0,0,0,.948-1.77,1.9,1.9,0,0,0-.4-1.677,2.437,2.437,0,0,1-.94,1.045",
    transform: "translate(-331.71 -109.254)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gj"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.584,
    height: 4.606,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.709,108.1c-.437.269-.909.409-1.345.715a1.893,1.893,0,0,0-.674,1.146,1.865,1.865,0,0,0,.447,1.723,2.574,2.574,0,0,1,.915-.6,8.187,8.187,0,0,0,1.048-.581,3.1,3.1,0,0,0,.95-1.779,1.9,1.9,0,0,0-.394-1.681,2.468,2.468,0,0,1-.946,1.061",
    transform: "translate(-331.64 -107.044)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gl"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.591,
    height: 4.644,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.647,105.9c-.437.275-.907.424-1.344.735a2,2,0,0,0-.7,1.284,1.821,1.821,0,0,0,.467,1.593,2.521,2.521,0,0,1,.913-.615,8.129,8.129,0,0,0,1.048-.6,3.11,3.11,0,0,0,.926-1.633,1.971,1.971,0,0,0-.362-1.837,2.514,2.514,0,0,1-.949,1.071",
    transform: "translate(-331.577 -104.833)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gn"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.59,
    height: 4.683,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "go"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.591,103.717c-.437.282-.906.436-1.343.754a2.059,2.059,0,0,0-.7,1.3,1.816,1.816,0,0,0,.465,1.59,2.559,2.559,0,0,1,.911-.624,8.69,8.69,0,0,0,1.054-.617,3.2,3.2,0,0,0,.928-1.65,1.975,1.975,0,0,0-.358-1.84,2.567,2.567,0,0,1-.952,1.085",
    transform: "translate(-331.518 -102.632)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gp"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.594,
    height: 4.73,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.542,101.519c-.44.288-.905.449-1.342.775a2.106,2.106,0,0,0-.707,1.32,1.8,1.8,0,0,0,.458,1.593,2.6,2.6,0,0,1,.916-.642,9.072,9.072,0,0,0,1.049-.628,3.257,3.257,0,0,0,.932-1.666,2,2,0,0,0-.355-1.852,2.613,2.613,0,0,1-.951,1.1",
    transform: "translate(-331.465 -100.418)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gr"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.593,
    height: 4.789,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.494,99.307c-.437.292-.9.461-1.342.79a2.2,2.2,0,0,0-.706,1.34,1.8,1.8,0,0,0,.454,1.6,2.726,2.726,0,0,1,.913-.655,8.8,8.8,0,0,0,1.05-.642,3.308,3.308,0,0,0,.935-1.688,2.006,2.006,0,0,0-.35-1.86,2.661,2.661,0,0,1-.955,1.118",
    transform: "translate(-331.418 -98.189)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gt"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.597,
    height: 4.846,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.453,97.073c-.435.3-.907.469-1.343.81a2.232,2.232,0,0,0-.7,1.364,1.8,1.8,0,0,0,.448,1.6,2.748,2.748,0,0,1,.913-.668,9.719,9.719,0,0,0,1.053-.655,3.4,3.4,0,0,0,.93-1.708,2.037,2.037,0,0,0-.345-1.881,2.706,2.706,0,0,1-.952,1.137",
    transform: "translate(-331.375 -95.936)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gv"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.593,
    height: 4.913,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.411,94.817c-.437.3-.9.482-1.339.829a2.323,2.323,0,0,0-.708,1.385,1.848,1.848,0,0,0,.447,1.617,2.848,2.848,0,0,1,.916-.689,8.791,8.791,0,0,0,1.047-.67,3.433,3.433,0,0,0,.933-1.729,2.07,2.07,0,0,0-.346-1.9,2.787,2.787,0,0,1-.95,1.156",
    transform: "translate(-331.335 -93.661)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gx"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.589,
    height: 4.988,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.372,92.533c-.439.311-.9.491-1.339.847a2.377,2.377,0,0,0-.707,1.407,1.864,1.864,0,0,0,.446,1.635,2.677,2.677,0,0,1,.915-.7,9.89,9.89,0,0,0,1.042-.686,3.519,3.519,0,0,0,.936-1.755,2.113,2.113,0,0,0-.342-1.917,2.843,2.843,0,0,1-.95,1.17",
    transform: "translate(-331.295 -91.363)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gz"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.586,
    height: 5.058,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ha"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.644,57.6a2.984,2.984,0,0,0-1.8.736,3.483,3.483,0,0,0-.459.67,1.629,1.629,0,0,0-.125,1.053,1.062,1.062,0,0,0,1.071.75,1.755,1.755,0,0,0,1.26-.544c.328-.413.473-.883.78-1.3a2.183,2.183,0,0,1,1.077-.781,2.084,2.084,0,0,0-1.559-.6c-.083,0-.165,0-.248.009",
    transform: "translate(-275.226 -57.592)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hb"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.292,
    height: 3.251,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.143,57.914a3.009,3.009,0,0,0-1.907.749,6.882,6.882,0,0,0-.634.99,2.16,2.16,0,0,1-.627.829,2.189,2.189,0,0,0,1.824.647,1.716,1.716,0,0,0,1.151-.539c.31-.4.459-.849.741-1.25a2.2,2.2,0,0,1,1.114-.836,2.014,2.014,0,0,0-1.526-.593c-.046,0-.091,0-.137,0",
    transform: "translate(-276.976 -57.912)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.83,
    height: 3.28,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "he"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.416,58.228a2.978,2.978,0,0,0-1.911.755,7.651,7.651,0,0,0-.662,1.029,1.986,1.986,0,0,1-.605.792,2.126,2.126,0,0,0,1.815.641,1.713,1.713,0,0,0,1.129-.54c.3-.383.454-.817.721-1.209a2.2,2.2,0,0,1,1.138-.881,1.96,1.96,0,0,0-1.5-.589l-.124,0",
    transform: "translate(-279.238 -58.226)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hf"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.803,
    height: 3.288,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.6,58.541a2.942,2.942,0,0,0-1.855.756,7.111,7.111,0,0,0-.642,1,2.225,2.225,0,0,1-.629.826,2.049,2.049,0,0,0,1.746.641,1.748,1.748,0,0,0,1.167-.547c.315-.4.476-.846.755-1.248a2.242,2.242,0,0,1,1.115-.849,1.923,1.923,0,0,0-1.477-.583c-.06,0-.12,0-.181.006",
    transform: "translate(-281.477 -58.535)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hh"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.784,
    height: 3.289,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.888,58.84a2.987,2.987,0,0,0-1.914.764,7.181,7.181,0,0,0-.65,1,2.284,2.284,0,0,1-.635.829,2.008,2.008,0,0,0,1.778.63,1.729,1.729,0,0,0,1.116-.544c.32-.4.483-.85.765-1.251a2.262,2.262,0,0,1,1.12-.853,1.887,1.887,0,0,0-1.459-.58c-.041,0-.081,0-.122,0",
    transform: "translate(-283.689 -58.836)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hj"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.779,
    height: 3.305,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.067,59.135a3,3,0,0,0-1.882.771,7.706,7.706,0,0,0-.666,1.007,2.222,2.222,0,0,1-.638.826,1.965,1.965,0,0,0,1.739.628,1.781,1.781,0,0,0,1.141-.552c.326-.4.492-.846.775-1.247a2.332,2.332,0,0,1,1.13-.86,1.866,1.866,0,0,0-1.453-.579c-.05,0-.1,0-.147,0",
    transform: "translate(-285.881 -59.13)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hl"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.786,
    height: 3.308,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.2,59.433a3.01,3.01,0,0,0-1.821.767,7.185,7.185,0,0,0-.664,1,2.362,2.362,0,0,1-.658.839,1.919,1.919,0,0,0,1.67.626,1.851,1.851,0,0,0,1.21-.56c.328-.4.5-.853.792-1.258a2.37,2.37,0,0,1,1.134-.852,1.83,1.83,0,0,0-1.424-.572q-.119,0-.237.011",
    transform: "translate(-288.059 -59.422)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hn"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.805,
    height: 3.299,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ho"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.423,59.715a3.063,3.063,0,0,0-1.852.774,7.634,7.634,0,0,0-.669.986,2.413,2.413,0,0,1-.671.852,1.88,1.88,0,0,0,1.676.617,1.861,1.861,0,0,0,1.194-.557c.34-.406.514-.865.822-1.273a2.421,2.421,0,0,1,1.13-.839,1.806,1.806,0,0,0-1.417-.567c-.072,0-.143,0-.214.008",
    transform: "translate(-290.231 -59.707)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.619,59.994a3.117,3.117,0,0,0-1.862.778,8.189,8.189,0,0,0-.677.984,2.434,2.434,0,0,1-.687.853,1.863,1.863,0,0,0,1.671.614,1.9,1.9,0,0,0,1.2-.562c.346-.405.532-.863.844-1.273a2.458,2.458,0,0,1,1.142-.839,1.791,1.791,0,0,0-1.413-.563c-.073,0-.147,0-.221.008",
    transform: "translate(-292.393 -59.986)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hr"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.859,
    height: 3.302,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.661,60.285a3.1,3.1,0,0,0-1.711.764,8.183,8.183,0,0,0-.7.986,2.527,2.527,0,0,1-.7.852,1.815,1.815,0,0,0,1.536.619,2.019,2.019,0,0,0,1.348-.574c.352-.4.542-.857.859-1.267a2.512,2.512,0,0,1,1.155-.843,1.789,1.789,0,0,0-1.408-.561,3.019,3.019,0,0,0-.385.025",
    transform: "translate(-294.555 -60.26)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ht"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.898,
    height: 3.277,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.849,60.553a3.179,3.179,0,0,0-1.73.765,8.808,8.808,0,0,0-.709.987,2.59,2.59,0,0,1-.709.849,1.8,1.8,0,0,0,1.535.617,2.048,2.048,0,0,0,1.361-.578c.36-.4.557-.856.88-1.265a2.57,2.57,0,0,1,1.168-.843,1.785,1.785,0,0,0-1.405-.557,3.1,3.1,0,0,0-.391.025",
    transform: "translate(-296.701 -60.528)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hv"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.944,
    height: 3.275,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.047,60.819a3.244,3.244,0,0,0-1.748.765,8.854,8.854,0,0,0-.723.986,2.671,2.671,0,0,1-.726.848,1.789,1.789,0,0,0,1.538.609,2.118,2.118,0,0,0,1.382-.574c.365-.4.571-.854.9-1.264a2.6,2.6,0,0,1,1.187-.842,1.8,1.8,0,0,0-1.409-.556,3.065,3.065,0,0,0-.4.027",
    transform: "translate(-298.85 -60.792)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hx"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.006,
    height: 3.27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.26,61.078a3.32,3.32,0,0,0-1.769.771,9.007,9.007,0,0,0-.74.984,2.7,2.7,0,0,1-.736.846,1.787,1.787,0,0,0,1.543.6,2.169,2.169,0,0,0,1.4-.574c.372-.4.582-.854.913-1.261a2.693,2.693,0,0,1,1.207-.841,1.808,1.808,0,0,0-1.418-.555,3.281,3.281,0,0,0-.4.026",
    transform: "translate(-301.015 -61.052)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hz"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.064,
    height: 3.267,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ia"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.489,61.342a3.386,3.386,0,0,0-1.788.763,9.339,9.339,0,0,0-.754.985,2.727,2.727,0,0,1-.753.843,1.8,1.8,0,0,0,1.552.6,2.232,2.232,0,0,0,1.422-.569c.382-.4.594-.856.935-1.261a2.726,2.726,0,0,1,1.226-.837,1.834,1.834,0,0,0-1.429-.553,3.212,3.212,0,0,0-.411.027",
    transform: "translate(-303.194 -61.315)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ib"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.134,
    height: 3.257,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ic"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.74,61.6a3.421,3.421,0,0,0-1.807.763,8.855,8.855,0,0,0-.768.979,2.829,2.829,0,0,1-.773.844,1.833,1.833,0,0,0,1.567.6,2.284,2.284,0,0,0,1.443-.573c.391-.4.61-.848.955-1.253a2.806,2.806,0,0,1,1.24-.837,1.866,1.866,0,0,0-1.447-.552,3.223,3.223,0,0,0-.411.026",
    transform: "translate(-305.392 -61.576)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.205,
    height: 3.249,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ie"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.017,61.864a3.511,3.511,0,0,0-1.83.759,9.548,9.548,0,0,0-.785.977,2.723,2.723,0,0,1-.785.841,1.863,1.863,0,0,0,1.582.6,2.358,2.358,0,0,0,1.466-.57c.4-.4.623-.843.972-1.248a2.8,2.8,0,0,1,1.253-.836,1.88,1.88,0,0,0-1.456-.553,3.338,3.338,0,0,0-.418.027",
    transform: "translate(-307.617 -61.837)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "if"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.274,
    height: 3.24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ig"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.18,50.063a13.5,13.5,0,0,0-7.529,2.164,3.429,3.429,0,0,0-1.1,1.359,2.63,2.63,0,0,0,1.223,3.238,13.5,13.5,0,0,0,7.637,1.744c2.552-.07,5.485-.553,7.559-2.164a2.627,2.627,0,0,0,1.044-3.3,3.466,3.466,0,0,0-1.171-1.3,12.51,12.51,0,0,0-7.028-1.754c-.215,0-.428,0-.64.009",
    transform: "translate(-235.367 -50.054)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ih"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.463,
    height: 8.6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ij"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.808,
    height: 110.499,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ik"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.711,390.085a5.574,5.574,0,0,1,1.153-.342c.465-.174.094-.248.936-.611a3.4,3.4,0,0,0-.5-.835c-4.726-6.426-40.205-41.838-40.205-44.06,0-15.484,0-29.267,0-44.749,0-3.228-24.382-18.308-27.7-19.9q-2.363.8-4.726,1.6-2.338.792-4.674,1.586c2.969,3.06,26.47,16.924,26.47,20.152,0,15.481,1.234,29.015,1.233,44.5,0,2.979,39.366,35.584,46.033,41.337.389.334,1.831,1.175,1.984,1.323",
    transform: "translate(-273.992 -279.585)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "il"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.519,364.254s1.485,3.062,1.9,3.909,4.738,7.209,5.855,6.811l-2.495-5.151a.626.626,0,1,1,.149-.07l2.493,5.14c.1-.058.14-.168.172-.374a25.335,25.335,0,0,0-1.831-8.067c-1.211-2.5-2.151-4.434-2.151-4.434Z",
    transform: "translate(-332.519 -362.019)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "im",
    x1: -29.578,
    y1: 4.088,
    x2: -29.488,
    y2: 4.088,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#844c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#844c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#e5d961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#e1d55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#d5c95a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#c2b552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    stopColor: "#a69946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#837637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#615329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    stopColor: "#857438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#e2c860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#e5ca61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#e1c65f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897,
    stopColor: "#d8ba59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#c9a650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954,
    stopColor: "#b48a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982,
    stopColor: "#996734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#844c28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "in"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.867,357.384l5.819,9.092,5.986-2.975-3.74-10.123Z",
    transform: "translate(-326.867 -353.378)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "io",
    x1: -23.387,
    y1: 4.402,
    x2: -23.315,
    y2: 4.402,
    xlinkHref: "#im"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ip"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.266,
    height: 45.042,
    transform: "translate(0 4.564) rotate(-26.409)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iq",
    x1: -7.661,
    y1: 2.322,
    x2: -7.635,
    y2: 2.322,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#090a0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#5e5e5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090a0e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ir"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.279,
    height: 10.725,
    transform: "translate(0 4.572) rotate(-26.413)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "is",
    x1: -20.078,
    y1: 4.479,
    x2: -20.016,
    y2: 4.479,
    xlinkHref: "#im"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "it"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.285,
    height: 1.447,
    transform: "translate(0 3.246) rotate(-26.461)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iu",
    x1: -46.237,
    y1: 8.946,
    x2: -46.097,
    y2: 8.946,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#090a0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090a0e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "iv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.174,267.9c.546,7.7,28.6,61.35,28.6,61.35l11.081-5.507s-25.1-51.16-31.776-59.332a2.558,2.558,0,0,0-2.069-.846c-2.547,0-5.983,2.3-5.838,4.334",
    transform: "translate(-282.169 -263.566)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iw",
    x1: -4.938,
    y1: 2.404,
    x2: -4.92,
    y2: 2.404,
    xlinkHref: "#iq"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ix"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.72,260.014a3.638,3.638,0,0,0-2.331,2.682,37.21,37.21,0,0,0,2.686,8.462s3.311-2,4.4-2.542c1.063-.528,4.2-1.735,4.2-1.735a46.978,46.978,0,0,0-4.963-7.18c-.031-.037-.067-.068-.1-.1a4.384,4.384,0,0,0-1.245-.154,6.735,6.735,0,0,0-2.65.567",
    transform: "translate(-280.389 -259.447)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iy",
    x1: -20.804,
    y1: 11.644,
    x2: -20.729,
    y2: 11.644,
    xlinkHref: "#im"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "iz"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.937,
    height: 3.168,
    transform: "matrix(0.896, -0.444, 0.444, 0.896, 0, 5.744)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ja",
    x1: -23.201,
    y1: 9.184,
    x2: -23.125,
    y2: 9.184,
    xlinkHref: "#im"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "jb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.785,267.488c2.136,6.458,6.618,11.2,8.756,17.659,1.365,3.2,4.356,1.783,2.471-1.228-3.845-5.609-4.907-12.05-8.755-17.66a.95.95,0,0,0-.716-.27c-.843,0-1.921.718-1.756,1.5",
    transform: "translate(-284.768 -265.988)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jc",
    x1: -15.197,
    y1: 6.841,
    x2: -15.143,
    y2: 6.841,
    xlinkHref: "#im"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "je"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 341.95,
    height: 323.091,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "jf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.95,163.363c0,89.218-76.546,161.547-170.972,161.547S0,252.581,0,163.363,76.549,1.819,170.977,1.819,341.95,74.145,341.95,163.363",
    transform: "translate(0 -1.819)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(184.239 321.969)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.001 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 318.562,
    height: 141.583,
    transform: "translate(-0.15 -0.861)",
    xlinkHref: "data:image/png;base64,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"
  }))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M454.7,310.21,259.86,221.8,67.6,288.447,230.074,400.189Z",
    transform: "translate(12.171 40.158)",
    fill: "#041e00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M443.837,299.489,437.368,262.9,66.543,273.8l157.7,113.294Z",
    transform: "translate(11.981 47.6)",
    fill: "#f9ecb7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.683 223.25)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 410.997,
    height: 454.407,
    transform: "translate(-109.202 143.842) rotate(-54.487)",
    fill: "url(#f)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M207.174,393.428l.27-.105,224.569-89.3-.26-1.5L207.121,391.7c-3.742-1.473-8.911-10.4-10.185-20.187-1.613-15.643,2.584-17.23,8.935-19.635.623-.236,1.266-.478,1.92-.739l215.92-85.657-.275-1.6L207.191,349.628c-.647.257-1.278.5-1.893.73-6.549,2.478-11.719,4.436-9.975,21.344,1.286,9.872,6.8,20.178,11.579,21.644Z",
    transform: "translate(35.106 47.777)",
    fill: "#28a000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.717,361.135s13.512-5.192,33.785-12.976c10.109-3.953,21.905-8.565,34.546-13.505,12.622-4.989,26.079-10.319,39.539-15.643,13.434-5.392,26.867-10.788,39.462-15.841,12.57-5.109,24.305-9.876,34.362-13.965,10.041-4.136,18.408-7.58,24.261-9.991,5.846-2.44,9.189-3.834,9.189-3.834s-3.386,1.285-9.3,3.538c-5.908,2.275-14.351,5.531-24.482,9.434-10.112,3.953-21.909,8.565-34.547,13.5-12.618,4.994-26.077,10.319-39.538,15.648-13.432,5.391-26.867,10.785-39.46,15.844-12.571,5.109-24.307,9.875-34.365,13.961-20.07,8.295-33.446,13.825-33.446,13.825",
    transform: "translate(35.599 49.859)",
    fill: "#e8c285"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.365,364.892l33.785-12.976c10.109-3.955,21.906-8.564,34.546-13.5,12.622-4.991,26.08-10.317,39.54-15.644L345.7,306.925l34.363-13.964c10.04-4.136,18.406-7.581,24.261-9.992l9.188-3.833-9.3,3.537c-5.909,2.278-14.351,5.53-24.482,9.437l-34.547,13.507c-12.618,4.991-26.078,10.316-39.537,15.643-13.433,5.391-26.866,10.787-39.458,15.844l-34.365,13.965c-20.07,8.292-33.447,13.823-33.447,13.823",
    transform: "translate(35.715 50.539)",
    fill: "#e8c285"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M199.015,368.649s13.513-5.188,33.784-12.977l34.546-13.5,39.54-15.644,39.461-15.844,34.363-13.962c10.041-4.136,18.406-7.582,24.262-9.993,5.845-2.441,9.187-3.833,9.187-3.833l-9.3,3.537c-5.91,2.277-14.353,5.531-24.482,9.437l-34.549,13.505c-12.616,4.992-26.077,10.318-39.538,15.645-13.431,5.392-26.865,10.785-39.458,15.844l-34.365,13.964c-20.07,8.293-33.446,13.823-33.446,13.823",
    transform: "translate(35.832 51.22)",
    fill: "#e8c285"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M199.663,372.4s13.514-5.187,33.784-12.975c10.109-3.953,21.908-8.563,34.548-13.5,12.622-4.991,26.079-10.319,39.539-15.644,13.434-5.391,26.866-10.787,39.461-15.841,12.57-5.109,24.305-9.876,34.363-13.964,10.039-4.136,18.406-7.58,24.261-9.992,5.845-2.444,9.187-3.835,9.187-3.835l-9.3,3.54c-5.909,2.276-14.352,5.53-24.482,9.435l-34.547,13.5c-12.618,4.995-26.079,10.317-39.539,15.647l-39.458,15.843c-12.571,5.109-24.307,9.876-34.365,13.964L199.663,372.4",
    transform: "translate(35.949 51.9)",
    fill: "#e8c285"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M200.312,376.161s13.514-5.191,33.786-12.974c10.109-3.954,21.906-8.564,34.546-13.505,12.621-4.99,26.079-10.317,39.539-15.644,13.434-5.393,26.869-10.787,39.461-15.84,12.571-5.111,24.307-9.877,34.363-13.967,10.041-4.135,18.406-7.58,24.261-9.989,5.845-2.442,9.188-3.834,9.188-3.834l-9.3,3.54-24.482,9.434c-10.112,3.954-21.909,8.564-34.547,13.505-12.618,4.99-26.078,10.318-39.538,15.645l-39.46,15.841c-12.571,5.11-24.305,9.878-34.364,13.966l-33.448,13.822",
    transform: "translate(36.066 52.58)",
    fill: "#e8c285"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(137.732 355.715)",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 88.489,
    height: 90.849,
    transform: "translate(-0.846 -0.357)",
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.453 431.01)",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 123.885,
    height: 23.597,
    transform: "translate(-0.611 -0.064)",
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.231 441.13)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.828,
    height: 34.27,
    transform: "matrix(0.998, -0.055, 0.055, 0.998, -2.05, -0.992)",
    fill: "url(#n)"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.573 345.642)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 213.555,
    height: 148.662,
    transform: "translate(-0.214 -0.912)",
    xlinkHref: "data:image/png;base64,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"
  }))))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.331 409.199)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 82.59,
    height: 77.871,
    transform: "translate(-0.465 -0.692)",
    xlinkHref: "data:image/png;base64,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"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.609 388.3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.153,
    height: 60.518,
    transform: "matrix(0.857, -0.516, 0.516, 0.857, -16.237, 9.79)",
    fill: "url(#s)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.799 331.473)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.952,
    height: 70.464,
    transform: "translate(-20.611 27.148) rotate(-52.771)",
    fill: "url(#u)"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(160.188 409.584)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.045.044l87.9-.037-.038,87.959L.007,88Z",
    transform: "matrix(0.725, -0.689, 0.689, 0.725, -32.401, 29.921)",
    fill: "url(#w)"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(164.743 414.513)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.04.04,78.9.006l-.033,78.452L.006,78.492Z",
    transform: "matrix(0.685, -0.729, 0.729, 0.685, -35.491, 31.988)",
    fill: "url(#y)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.788 312.975)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 234.023,
    height: 238.985,
    transform: "matrix(0.634, -0.773, 0.773, 0.634, -76.954, 89.796)",
    fill: "url(#aa)"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.192 315.486)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 208.888,
    height: 208.98,
    transform: "matrix(0.634, -0.773, 0.773, 0.634, -77.027, 88.555)",
    fill: "url(#ac)"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.65,409.091a31.33,31.33,0,0,1-4.492-.944c-17.219-4.9-20.518-15-20.258-29.732.26-14.473,10.677-29.626,10.78-29.776l1.005.7c-.1.15-10.314,15.008-10.561,29.1-.256,14.51,2.83,23.834,19.367,28.532,16.9,4.8,28.9-6.339,32.838-15,4.367-9.591,4.5-20.3.335-27.286A27.529,27.529,0,0,0,169,352.553c-18.376-1.695-24,14.348-25.293,19.307-2.9,11.183-.5,24.166,5.369,28.935a15.881,15.881,0,0,0,11.791,3.218c3.725-.431,9.215-2.294,14.195-8.733,8.238-10.651-1.762-19.219-2.19-19.58l-21.692-17.294.9-.836,21.567,17.182c.125.1,11.35,9.687,2.386,21.274-5.239,6.775-11.065,8.746-15.024,9.2a17.077,17.077,0,0,1-12.7-3.488c-6.2-5.041-8.793-18.589-5.781-30.193,3.6-13.86,13.538-21.42,26.586-20.217a28.836,28.836,0,0,1,21.608,12.734c4.361,7.308,4.255,18.462-.274,28.413-3.764,8.257-14.531,18.67-29.793,16.613",
    transform: "translate(24.466 63.123)",
    fill: "#f5f5f5"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.113 346.667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.795,
    height: 88.047,
    transform: "matrix(0.634, -0.773, 0.773, 0.634, -33.749, 39.168)",
    fill: "url(#af)"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.985 377.983)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ag)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114.379,
    height: 122.384,
    transform: "translate(-31.798 43.882) rotate(-54.099)",
    fill: "url(#ah)"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.868 435.743)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.177,
    height: 23.087,
    transform: "translate(-4.413 1.447) rotate(-19.079)",
    fill: "url(#aj)"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.808 435.475)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ak)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.962,
    height: 23.284,
    transform: "matrix(0.932, -0.362, 0.362, 0.932, -4.532, 1.671)",
    fill: "url(#al)"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.955 436.499)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#am)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.081,
    height: 34.267,
    transform: "translate(-1.658 0.092) rotate(-3.181)",
    fill: "url(#an)"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.947 432.174)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ao)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.04.038,74.885.006l-.033,78.671L.006,78.709Z",
    transform: "translate(-15.359 16.643) rotate(-48.181)",
    fill: "url(#ap)"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.75 434.709)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.032.03,60.234,0l-.027,63.5-60.2.026Z",
    transform: "matrix(0.667, -0.745, 0.745, 0.667, -11.674, 12.648)",
    fill: "url(#ar)"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.75 434.709)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.032.03,60.234,0l-.027,63.5-60.2.026Z",
    transform: "matrix(0.667, -0.745, 0.745, 0.667, -11.674, 12.648)",
    fill: "url(#ar)"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.75 434.709)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#au)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.258,
    height: 17.835,
    transform: "matrix(0.998, -0.065, 0.065, 0.998, -1.217, 0.058)",
    fill: "url(#av)"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.567,335.3a44.428,44.428,0,0,0-10.472-7.591c-12.538-5.877-24.7-4.851-32.01-.743-11.606,6.511-13.251,21.775-14.589,31.615-2.7,19.9-14.628,19.35-15,19.452l3.291,3.9c.512-.123,12.551-3.225,15.427-24.063,1.2-8.717,3.911-20.927,13.457-26.29,8.729-4.9,22.148-3.641,39.894,3.716",
    transform: "translate(16.294 58.588)",
    fill: "#c1c6c1"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.959 390.658)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ax)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110.878,
    height: 122.856,
    transform: "translate(-27.154 37.341) rotate(-54.099)",
    fill: "url(#ay)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M181.41,347.517s-4.137-8.755-14.152-10.779c-10.733-2.257-20.254-.869-28.294,3.11-9.561,4.74-15.048,12.972-17.969,19.051-.4.824-.769,1.617-1.129,2.376-4.194,8.874-5.7,13.283-17.6,16.087-13.635,3.214-29.519,2.111-29.679,2.122l-.376.024a3.577,3.577,0,0,0,1.6,2.278c.408.239,20.613,2.075,29.439,0,14.386-3.388,17.028-8.981,21.407-18.247.354-.748.7-1.541,1.115-2.342,8.649-16.682,32.47-31.05,55.644-13.678",
    transform: "translate(13.001 60.773)",
    fill: "#c1c6c1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.856 292.566)",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bb)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 251.31,
    height: 133.324,
    transform: "translate(-0.848 -0.984)",
    xlinkHref: "data:image/png;base64,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"
  })))))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5,317.46l141.192-95.989,160.2,26.267L297.307,357.671Z",
    transform: "translate(19.535 40.099)",
    fill: "#04042b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M115.484,310.248l.123-29.646,293.02-41.833L300.015,349.276Z",
    transform: "translate(20.793 43.231)",
    fill: "#f9ecb7"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(129.329 230.006)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.171.173,341.838.027l-.144,337.239L.027,337.412Z",
    transform: "matrix(0.722, -0.692, 0.692, 0.722, -83.975, 80.238)",
    fill: "url(#bd)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M297.395,348.477l-.224-.047L108.5,308.746v-1.213L297.2,347.11c2.742-1.668,5.595-9.387,5.268-17.255-.853-12.517-4.367-13.2-9.687-14.223-.525-.1-1.062-.2-1.612-.32l-181.378-38v-1.3l181.646,38.025c.543.115,1.073.216,1.588.315,5.484,1.059,9.816,1.894,10.736,15.426.332,7.937-2.607,16.789-6.163,18.591Z",
    transform: "translate(19.534 49.975)",
    fill: "#2d57a0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160.989 296)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bf)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.837,284.544c-6.351-1.449-131.579-26.393-169.391-33.921l-6.019,4.094c29.459,5.864,167.745,33.4,174.258,34.886a18.66,18.66,0,0,1,11.269,9.037c2.233,4.168,4.511,13.251.32,24.744,2.164-2.092,3.679-3.557,6.16-5.951,3.134-6.313.214-18.313-1.837-22.144-3.344-6.245-9.532-9.551-14.759-10.745",
    transform: "translate(-136.426 -250.623)",
    fill: "#96d7ea"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.856 280.439)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bg)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.236,270.69c-6.191-1.414-124.535-24.991-165.982-33.241l-10.535,7.161c28.819,5.734,167.989,33.446,174.5,34.932,2.643.6,6.513,3.457,9.2,8.474,2.066,3.856,4.889,11.864,1.068,22.538,3.483-3.366,5.693-5.493,9.506-9.177,2.523-5.8-.324-16.7-2.109-20.035-3.658-6.831-9.8-9.319-15.646-10.652",
    transform: "translate(-150.719 -237.448)",
    fill: "#96d7ea"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M298.656,322.077l-28.322-5.61-28.994-5.922c-10.6-2.207-21.9-4.567-33.209-6.923-11.292-2.415-22.585-4.831-33.172-7.093l-28.912-6.308-20.428-4.558-7.742-1.766,7.793,1.519,20.528,4.09c8.486,1.734,18.386,3.757,28.994,5.922,10.6,2.21,21.9,4.568,33.209,6.927,11.292,2.417,22.584,4.829,33.17,7.095,10.578,2.308,20.453,4.46,28.916,6.307l28.17,6.321",
    transform: "translate(21.223 51.401)",
    fill: "#e8c285"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M298.656,325.12s-11.328-2.243-28.322-5.612l-28.994-5.919-33.209-6.926c-11.292-2.415-22.585-4.828-33.172-7.093-10.577-2.307-20.449-4.458-28.912-6.307L125.618,288.7c-4.927-1.123-7.742-1.763-7.742-1.763s2.834.55,7.793,1.516l20.528,4.091c8.486,1.735,18.386,3.756,28.994,5.923L208.4,305.4c11.292,2.414,22.584,4.828,33.17,7.093,10.578,2.308,20.453,4.461,28.916,6.309,16.9,3.791,28.17,6.321,28.17,6.321",
    transform: "translate(21.223 51.952)",
    fill: "#e8c285"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M298.656,328.16s-11.328-2.242-28.322-5.61c-8.486-1.731-18.386-3.753-28.994-5.919L208.131,309.7l-33.172-7.092c-10.577-2.309-20.449-4.462-28.912-6.308l-20.428-4.559c-4.927-1.123-7.742-1.763-7.742-1.763l7.793,1.516c4.955.987,12.034,2.4,20.528,4.09l28.994,5.923,33.209,6.927c11.292,2.414,22.584,4.828,33.17,7.093l28.916,6.308,28.17,6.32",
    transform: "translate(21.223 52.503)",
    fill: "#e8c285"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M298.656,331.2s-11.328-2.242-28.322-5.61c-8.486-1.734-18.386-3.757-28.994-5.922-10.6-2.21-21.9-4.568-33.209-6.925l-33.172-7.093c-10.577-2.307-20.449-4.461-28.912-6.309-8.453-1.884-15.5-3.456-20.428-4.557l-7.742-1.766,7.793,1.519c4.955.986,12.034,2.4,20.528,4.09,8.486,1.735,18.386,3.757,28.994,5.923l33.209,6.924,33.17,7.1c10.578,2.309,20.453,4.461,28.916,6.307l28.17,6.322",
    transform: "translate(21.223 53.053)",
    fill: "#e8c285"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M298.656,334.244l-28.322-5.609-28.994-5.923c-10.6-2.207-21.9-4.566-33.209-6.923-11.292-2.415-22.585-4.831-33.172-7.092l-28.912-6.309c-8.453-1.887-15.5-3.458-20.428-4.557l-7.742-1.766,7.793,1.518c4.955.986,12.034,2.4,20.528,4.091,8.486,1.733,18.386,3.756,28.994,5.921,10.6,2.21,21.9,4.567,33.209,6.928,11.292,2.413,22.584,4.828,33.17,7.093,10.578,2.307,20.453,4.46,28.916,6.307l28.17,6.321",
    transform: "translate(21.223 53.604)",
    fill: "#e8c285"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175.977 257.812)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bh)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bi)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 264.289,
    height: 164.001,
    transform: "translate(-0.15 -4.023)",
    xlinkHref: "data:image/png;base64,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"
  }))))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(319.129 57.987)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bj)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.988,
    height: 87.335,
    transform: "translate(0 0)",
    fill: "url(#bk)"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.7,97.5,275.929,55.3l-32.963,3.1S336.078,142.018,359.7,97.5",
    transform: "translate(43.746 10.013)",
    fill: "#f9ecb7"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(282.18 62.576)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bm)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123.526,
    height: 242.073,
    fill: "url(#bn)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(282.18 83.266)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bp)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.076,115.114c-4.667-2.4-87.95-44.613-87.95-44.613V84.874s83.283,42.218,87.95,44.614,29.192,1.358,35.575-6.627V108.487c-6.383,7.985-30.909,9.023-35.575,6.627",
    transform: "translate(-239.126 -70.501)",
    fill: "#9fe800"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(282.18 215.754)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.076,236.378c-4.667-2.4-87.95-53.7-87.95-53.7v7.188s83.283,51.3,87.95,53.7,29.192,1.355,35.575-6.627v-7.189c-6.383,7.985-30.909,9.023-35.575,6.629",
    transform: "translate(-239.126 -182.679)",
    fill: "#9fe800"
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M335.5,100.029c-5.488,0-8.2-1.276-11.719-2.934-.631-.3-1.289-.607-2-.926-7.274-3.263-81.9-42.04-82.656-42.433l1.559-.268c.753.391,74.24,38.573,81.489,41.828.712.319,1.375.632,2.012.932,5.84,2.749,9.366,4.409,28.226.634,6.322-1.6,8.4-3.829,8.99-4.7L276.075,49.147l1.482-.325,85.1,42.9-.139.4c-.048.141-1.3,3.5-9.889,5.676-7.957,1.592-13.238,2.232-17.126,2.232",
    transform: "translate(43.054 8.84)",
    fill: "#71d337"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M327.216,106.519,241.228,63.7l.135,42.817s62.236,44.52,85.853,0",
    transform: "translate(43.433 11.534)",
    fill: "#492e19"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M330.486,112.1,246.722,69.91l-32.966,3.1s93.112,83.612,116.73,39.091",
    transform: "translate(38.486 12.658)",
    fill: "#f9ecb7"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(247.713 79.825)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#br)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123.524,
    height: 242.073,
    transform: "translate(0 0)",
    fill: "url(#bs)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(247.713 100.514)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.867,129.719c-4.666-2.4-87.949-44.614-87.949-44.614V99.48S293.2,141.7,297.867,144.094s29.192,1.357,35.574-6.627V123.091c-6.382,7.986-30.909,9.024-35.574,6.628",
    transform: "translate(-209.918 -85.105)",
    fill: "#edc688"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(247.713 233.002)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bv)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.867,250.983c-4.666-2.4-87.949-53.7-87.949-53.7v7.189s83.283,51.3,87.949,53.7,29.192,1.356,35.574-6.627v-7.189c-6.382,7.985-30.909,9.023-35.574,6.628",
    transform: "translate(-209.918 -197.283)",
    fill: "#edc688"
  })))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M306.289,114.634c-5.491,0-8.2-1.276-11.721-2.935-.631-.3-1.287-.606-2-.924-7.274-3.264-81.9-42.043-82.654-42.433l1.558-.269c.754.39,74.242,38.573,81.491,41.828.709.32,1.374.632,2.008.932,5.841,2.751,9.37,4.409,28.227.634,6.324-1.6,8.4-3.828,8.99-4.7L246.865,63.752l1.483-.325,85.093,42.9-.136.4c-.051.142-1.3,3.5-9.892,5.676-7.957,1.593-13.239,2.233-17.125,2.233",
    transform: "translate(37.795 11.484)",
    fill: "#38a89f"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M296.874,152.368l-83.635-47.1L208.1,146.325s58.861,47.06,88.779,6.043",
    transform: "translate(37.467 19.06)",
    fill: "#633e1f"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M298.837,157.6l-81.412-46.346-34.47.652s85.967,86.71,115.882,45.694",
    transform: "translate(32.941 20.143)",
    fill: "#f9ecb7"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.402 126.129)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bw)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.272,98.536l173.9,11.832L309.338,357.7l-173.9-11.832Z",
    transform: "translate(-166.017 -108.288)",
    fill: "url(#bx)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(207.606 145.962)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bz)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.145,172.547c-4.53-2.626-85.44-48.961-85.44-48.961l-1.775,13.778s80.91,46.338,85.44,48.963,30.019,3.354,37.6-3.85c.734-5.707,1.341-10.413,1.775-13.779-7.588,7.206-33.077,6.476-37.6,3.849",
    transform: "translate(-175.93 -123.586)",
    fill: "#fced83"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.141 272.973)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ca)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.03,288.8c-4.53-2.628-84.319-57.671-84.319-57.671l-.886,6.888s79.79,55.045,84.319,57.671,30.018,3.36,37.6-3.849q.487-3.754.887-6.891c-7.585,7.209-33.074,6.475-37.6,3.853",
    transform: "translate(-162.825 -231.126)",
    fill: "#fced83"
  })))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M273.54,158.264c-5.676-.387-8.318-1.8-11.757-3.638-.617-.331-1.257-.674-1.948-1.028-7.12-3.642-79.508-46.069-80.239-46.5l1.646-.149c.73.43,72.009,42.206,79.1,45.837.7.355,1.342.7,1.964,1.035,5.7,3.047,9.141,4.886,29.111,2.6,6.733-1.09,9.155-3.079,9.873-3.871L218.37,105.3l1.573-.208,82.7,47.118-.19.371c-.07.133-1.776,3.266-10.93,4.745-8.422.967-13.966,1.208-17.983.935",
    transform: "translate(32.336 19.028)",
    fill: "#d3b539"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(171.015 145.655)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 242.004,
    height: 153.158,
    transform: "translate(-32.143 222.221) rotate(-81.763)",
    fill: "url(#cc)"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.921,137.01s11.249-11.866,39.456-1.926c29.04,16.547,74.58,43.468,74.58,43.468L235.519,344.143l-23.892,4.65Z",
    transform: "translate(26.093 23.739)",
    fill: "#f9ecb7"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.593 151.551)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ce)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116.732,
    height: 226.823,
    fill: "url(#cf)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(151.615 288.449)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ch)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.482,252.092l92.333,57.252,1.29-8.959L129.537,244.23Z",
    transform: "translate(-128.482 -244.23)",
    fill: "#45afaa"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.764 274.934)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ci)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.3,238.135,223.055,293.6l.909-6.3-92.945-54.519Z",
    transform: "translate(-130.303 -232.787)",
    fill: "#45afaa"
  })))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M215.277,355.808l-.992.288,24.433-172.839c-5.591-3.165-89.628-50.741-91.15-51.609-.177-.1-.366-.2-.559-.3-.974-.511-2.077-1.09-2.118-2.1-.032-.805.634-1.613,2.1-2.54,4.518-2.859,13.628-4.238,22.663-3.431,9.386.837,17.759,5.246,25.529,9.688,6.8,3.893,71.3,41.084,71.952,41.459l.281.162-.045.321-24.308,175-1.017.356,24.331-175.167c-4.668-2.689-65.1-37.535-71.67-41.3-7.677-4.389-15.944-8.745-25.137-9.565-10.219-.913-18.444.993-22.065,3.288-1.516.958-1.661,1.5-1.654,1.69.019.458.9.921,1.607,1.293.2.106.4.213.585.315,1.568.893,90.538,51.263,91.436,51.772l.286.162Z",
    transform: "translate(26.087 22.278)",
    fill: "#5cd6ca"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M173.863,135.284l3.2,1.782,8.415,4.761c3.466,1.995,7.507,4.324,11.842,6.818,4.318,2.523,8.92,5.214,13.525,7.906l13.461,8.016c4.3,2.555,8.266,5.005,11.694,7.071l8.236,5.063c1.977,1.238,3.109,1.943,3.109,1.943l-3.206-1.781-8.411-4.761c-3.467-2-7.531-4.292-11.845-6.819s-8.919-5.216-13.523-7.906L196.9,149.361l-11.7-7.071c-3.407-2.094-6.246-3.841-8.234-5.064l-3.111-1.942",
    transform: "translate(31.304 24.494)",
    fill: "#e8c285"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M170.176,135.284l3.2,1.782,8.415,4.761c3.467,1.995,7.51,4.324,11.842,6.818,4.318,2.523,8.921,5.214,13.525,7.906,4.581,2.729,9.165,5.456,13.461,8.016s8.269,5.005,11.693,7.071c3.408,2.094,6.248,3.842,8.237,5.063,1.978,1.238,3.109,1.943,3.109,1.943l-3.205-1.781c-2.032-1.15-4.931-2.792-8.413-4.761-3.466-2-7.53-4.292-11.845-6.819s-8.919-5.216-13.523-7.906l-13.457-8.016-11.7-7.071c-3.408-2.094-6.246-3.841-8.236-5.064l-3.111-1.942",
    transform: "translate(30.64 24.494)",
    fill: "#e8c285"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M166.491,135.284l3.2,1.782,8.414,4.761c3.467,1.995,7.511,4.324,11.844,6.818l13.523,7.906c4.581,2.729,9.164,5.456,13.461,8.016s8.269,5.005,11.693,7.071c3.408,2.094,6.248,3.842,8.237,5.063,1.978,1.238,3.109,1.943,3.109,1.943l-3.205-1.781c-2.031-1.15-4.934-2.792-8.414-4.761-3.465-2-7.532-4.292-11.845-6.819s-8.919-5.216-13.523-7.906l-13.457-8.016-11.7-7.071-8.236-5.064-3.109-1.942",
    transform: "translate(29.976 24.494)",
    fill: "#e8c285"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M162.8,135.284l3.205,1.782,8.415,4.761,11.842,6.818,13.525,7.906c4.581,2.729,9.163,5.456,13.46,8.016s8.27,5.005,11.693,7.071c3.409,2.094,6.248,3.842,8.237,5.063,1.98,1.238,3.111,1.943,3.111,1.943l-3.207-1.781c-2.028-1.15-4.93-2.792-8.413-4.761-3.465-2-7.529-4.292-11.845-6.819s-8.916-5.216-13.522-7.906l-13.458-8.016-11.7-7.071-8.234-5.064-3.111-1.942",
    transform: "translate(29.313 24.494)",
    fill: "#e8c285"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M241.523,172.678s-1.313,10.222-3.288,25.555c-1.022,7.662-2.218,16.6-3.5,26.175-1.312,9.569-2.713,19.78-4.111,29.993-1.443,10.2-2.885,20.406-4.236,29.968-1.388,9.563-2.68,18.488-3.789,26.136-2.292,15.289-3.819,25.48-3.819,25.48s1.316-10.222,3.286-25.555c1.023-7.659,2.218-16.6,3.5-26.172,1.311-9.572,2.709-19.783,4.111-29.992,1.442-10.205,2.885-20.405,4.24-29.973,1.384-9.564,2.674-18.485,3.786-26.136,2.289-15.288,3.817-25.479,3.817-25.479",
    transform: "translate(39.391 31.264)",
    fill: "#e8c285"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M238.182,173.151s-1.313,10.223-3.286,25.557c-1.023,7.66-2.217,16.6-3.5,26.171-1.311,9.572-2.711,19.783-4.112,29.994-1.441,10.2-2.884,20.4-4.235,29.972-1.387,9.56-2.679,18.486-3.787,26.134-2.292,15.289-3.821,25.479-3.821,25.479s1.316-10.22,3.288-25.553c1.022-7.66,2.217-16.6,3.5-26.175,1.313-9.572,2.712-19.784,4.114-29.991,1.441-10.2,2.884-20.407,4.239-29.974,1.384-9.562,2.676-18.486,3.784-26.136,2.292-15.286,3.819-25.479,3.819-25.479",
    transform: "translate(38.79 31.35)",
    fill: "#e8c285"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M234.842,173.626s-1.316,10.222-3.286,25.552c-1.023,7.663-2.218,16.6-3.5,26.177-1.311,9.569-2.709,19.78-4.11,29.987-1.442,10.207-2.885,20.41-4.238,29.976-1.385,9.561-2.676,18.486-3.786,26.133L212.1,336.931s1.316-10.221,3.286-25.553c1.024-7.662,2.22-16.6,3.5-26.172,1.313-9.572,2.712-19.783,4.112-29.992,1.443-10.205,2.885-20.407,4.239-29.976,1.387-9.558,2.678-18.484,3.786-26.132,2.29-15.289,3.82-25.479,3.82-25.479",
    transform: "translate(38.188 31.436)",
    fill: "#e8c285"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M231.5,174.1s-1.313,10.223-3.285,25.552c-1.023,7.665-2.22,16.6-3.5,26.176C223.4,235.4,222,245.61,220.6,255.819c-1.441,10.205-2.885,20.406-4.236,29.972-1.387,9.562-2.679,18.488-3.788,26.137-2.292,15.285-3.819,25.477-3.819,25.477s1.315-10.22,3.285-25.551c1.023-7.663,2.22-16.6,3.5-26.175,1.311-9.572,2.708-19.784,4.111-29.993,1.441-10.2,2.884-20.407,4.238-29.972,1.387-9.562,2.678-18.486,3.788-26.134,2.288-15.289,3.816-25.48,3.816-25.48",
    transform: "translate(37.587 31.522)",
    fill: "#e8c285"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.837 129.862)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cj)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ck)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 199.396,
    height: 55.453,
    transform: "translate(-4.389 -0.084)",
    xlinkHref: "data:image/png;base64,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"
  })))))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M342.166,168.208c-.428-.007-.644-.014-1.073-.02-1.179-13.616-2.642-26.714-5.814-39.932l.674-.328c3.305,13.32,4.9,26.538,6.213,40.28",
    transform: "translate(60.366 23.162)",
    fill: "#ffb600"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M339.326,169.7c-.433-.007-.65-.013-1.083-.019a369.171,369.171,0,0,0-4.143-41.453l.707-.233a376.292,376.292,0,0,1,4.52,41.7",
    transform: "translate(60.154 23.175)",
    fill: "#e59e00"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M340.589,169.493c-.434,0-.649-.012-1.082-.018a367.9,367.9,0,0,0-4.744-41.263c.282-.093,1.025-.33,1.309-.423a376.306,376.306,0,0,1,4.517,41.7",
    transform: "translate(60.273 23.137)",
    fill: "#e59e00"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M338.136,169.941c-.433,0-.649-.012-1.081-.019a369.4,369.4,0,0,0-4.146-41.452c.286-.092.428-.141.708-.233a376.585,376.585,0,0,1,4.518,41.7",
    transform: "translate(59.94 23.218)",
    fill: "#e59e00"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M341.268,169.44l-1.088-.027c-.933-14.047-2.244-27.585-5.113-41.309l.686-.283c3.01,13.81,4.448,27.462,5.516,41.619",
    transform: "translate(60.328 23.143)",
    fill: "#ffb600"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M340.423,169.619l-1.088-.025c-.936-14.049-2.246-27.586-5.114-41.31.279-.112.414-.169.687-.282,3.009,13.809,4.448,27.461,5.516,41.617",
    transform: "translate(60.176 23.176)",
    fill: "#ffb600"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M338.3,170.094c-.434,0-.654.006-1.088.008-.608-14.023-1.389-27.946-2.825-41.9.288-.052.431-.079.719-.132,1.562,13.987,2.464,27.952,3.194,42.022",
    transform: "translate(60.205 23.188)",
    fill: "#ffb600"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M337.009,170.129c-.433,0-.655.006-1.089.007-.451-14.021-1.072-27.946-2.351-41.91.288-.053.434-.078.72-.132,1.407,14,2.148,27.967,2.72,42.035",
    transform: "translate(60.058 23.192)",
    fill: "#ffb600"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M335.3,170.163c-.435.008-.651.014-1.086.021-.256-14.006-.609-27.978-1.329-41.965.288-.034.43-.054.719-.087.846,14.006,1.323,28,1.7,42.031",
    transform: "translate(59.935 23.199)",
    fill: "#e59e00"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M328.69,168.592c.557-13.792,1.428-27.078,4-40.56l.69.291c-2.434,13.374-3.292,26.132-3.724,39.792-.326.544-.8.4-.962.477",
    transform: "translate(59.18 23.181)",
    fill: "#ffb600"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M330.918,169.688c.118-14.114.11-27.568,1.781-41.545.287.077.847.008,1.134.086a371.354,371.354,0,0,0-1.863,41.618c-.432.03-.617-.189-1.051-.159",
    transform: "translate(59.581 23.201)",
    fill: "#e59e00"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M330.2,169.924a371.741,371.741,0,0,1,2.195-41.642l.72.194a371.347,371.347,0,0,0-1.862,41.619c-.433.028-.62-.2-1.053-.171",
    transform: "translate(59.451 23.226)",
    fill: "#e59e00"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M331.616,169.131a372.778,372.778,0,0,1,2.193-41.7c.288.077.433.117.72.193a371.616,371.616,0,0,0-1.863,41.619c-.433.03-.616-.142-1.049-.111",
    transform: "translate(59.707 23.072)",
    fill: "#e59e00"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M332.619,168.976a358.9,358.9,0,0,1,2.215-40.929l.719.194a371.012,371.012,0,0,0-1.863,41.618c-.433.028-.637-.911-1.07-.882",
    transform: "translate(59.887 23.184)",
    fill: "#e59e00"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M329.543,169.774c.288-14.2.972-27.9,3.219-41.859.279.1.418.148.7.246a293.1,293.1,0,0,0-2.906,41.387c-.434.035-.581.193-1.014.227",
    transform: "translate(59.334 23.16)",
    fill: "#ffb600"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M329.336,169.78c.288-14.2.971-27.9,3.218-41.858.28.1.418.148.7.246a285.7,285.7,0,0,0-2.922,40.846c-.433.033-.565.733-1,.767",
    transform: "translate(59.296 23.161)",
    fill: "#ffb600"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M332.19,170.087c-.041-14.088.1-27.906.886-41.958.289.038,1.08.043,1.369.08-.665,14.007-1.325,27.966-1.162,42-.435.022-.658-.146-1.093-.124",
    transform: "translate(59.809 23.199)",
    fill: "#ffb600"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M333.425,170.227c-.2-14.078-.216-28.065.409-42.121l.725.093c-.507,14.012-.365,27.95-.044,41.976-.433.021-.655.028-1.09.052",
    transform: "translate(60.01 23.194)",
    fill: "#ffb600"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M335.059,170.168c-.4-14.029-.7-28.03-.614-42.063.29.018.432.031.721.05.054,14,.464,27.976.979,41.974-.434.019-.654.024-1.087.04",
    transform: "translate(60.214 23.194)",
    fill: "#ffb600"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M334.627,169.8c-.394-14.03-.692-28.03-.614-42.062.29.019.433.031.723.05.053,14,.461,27.974.978,41.974-.433.017-.654.022-1.088.039",
    transform: "translate(60.136 23.127)",
    fill: "#ffb600"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M336.746,169.335c-.394-14.031-1.921-27.649-1.841-41.681.289.018.433.031.723.048.053,14,1.689,27.594,2.206,41.591-.434.018-.654.022-1.088.041",
    transform: "translate(60.298 23.113)",
    fill: "#ffb600"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.251 64.356)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cl)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cm)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 186.323,
    height: 108.17,
    transform: "translate(-0.535 -0.103)",
    xlinkHref: "data:image/png;base64,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"
  })))))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.548,121.523,116.566,61.913l-.093-3.34,294.467-8.1.091,3.34Z",
    transform: "translate(20.971 9.138)",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.548,120.511,116.566,60.9l-.093-3.34,135.95-1.5,13,59.72Z",
    transform: "translate(20.971 10.15)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.456,127.32,116.474,67.711,261.956,0,410.939,59.608Z",
    transform: "translate(20.971 0)",
    fill: "#3d3d3d"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(283.433 62.5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#co)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.068 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4.531,
    height: 3.964,
    transform: "translate(-0.153 -0.515)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAIAAAC6O5sJAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACKADAAQAAAABAAAABwAAAAA0HM65AAAAo0lEQVQIHTXNQQrCMBQE0EloVVDsQlDqSuzaK5gKnkS8hzmQV5C0V9CVm+qyiChtsSSaGr+Is/iLNwOfOefwT7GTcAiWkoBRoc+J2UtXpdyHzmFu8EPh6Sy5bxfBDH6ERsPWMFd0prFXKtmN0BqA5u8nbInhSrUnMbd5CvalV4XqCPQEKf3g3ljYAuaC+oRHRvOElML7c2kbURzAws1orX5K9wN9BUGN/qTJdwAAAABJRU5ErkJggg=="
  })))))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(285.496 62.878)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cq)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cr)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.097,
    height: 3.964,
    transform: "translate(-0.019 -0.326)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAIAAABV+fA3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACaADAAQAAAABAAAABwAAAACzugX6AAAAsElEQVQIHSWOTQ7BUBSFz+t71dImJsJEJFiExKQdWItteJZiGwbSLsASmBBEoyHS9vVP3cfJzR18X87NZU3T4Bd1DMpLwG3UGT45ugvJ/i7a+KYZig6qFEUMdUNr6AnqvHbSKML2GMJB9UbxgDXyBsvAUIcg26+tPoQLMOQReE8L6hhUIsoE6gTqivQEZyZJUPTNMgGPkZ2R3+HOV/bEJ0jRvzy3knE0NeypT/Pjen0BCVhDYA/qwq0AAAAASUVORK5CYII="
  })))))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(288.167 63.248)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cs)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ct)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.964,
    transform: "translate(-0.424 -0.129)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAIAAAC+zks0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABwAAAADgIF5+AAAArElEQVQIHWP8//8/Axj8uH/g6/GGPy8OMjAx/PnMwCJuL552gAUqd+/Ah02OnFIMPEYMvz4wfL7B8OPuQaAUI0T3805GAWMGdmGG//8Yvt5n+PXDXiTmAFCaCYhfzHDgkmNgYmcA2vP7M8O3Bww8lg1AcSBg+XH3ANC+P+wg+/7/Zfhyi4FZxJ5D2QEsCzb85WyHv68PMrIwMDIxMAnZiyUdgMgBSajdcD4aAwAY4UZXDfuOIQAAAABJRU5ErkJggg=="
  })))))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(290.807 63.613)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cu)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cv)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.097,
    height: 3.964,
    transform: "translate(-0.232 -0.494)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAIAAABV+fA3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACaADAAQAAAABAAAABwAAAACzugX6AAAAsElEQVQIHWP8//8/AxL4uLeBgYmBXc6BQ9mBESL34+6BL8caWJgPMjIx/HzN8PMtA6ukPQtEz5sljoImDGyCDP9+M/z7xfDzFQOHkgNI7sPuBm4lkAQzN8PfNwy/3jGIJu4HyjEBTftxoZGVjwFo7Z9PDF/uMTDy2gMlgHoYH5QysAoxcMowMLMx/P3B8Ok6g3w71HXM/Uf///vJ8O3qwT9fGFhV6gVcGliEFICagAAAMmc/AATZwUQAAAAASUVORK5CYII="
  })))))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(293.418 63.968)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cw)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cx)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.097,
    height: 3.964,
    transform: "translate(-0.011 -0.282)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAIAAABV+fA3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACaADAAQAAAABAAAABwAAAACzugX6AAAArElEQVQIHT2OzQnCQBSEZ7MJKgbNRcSbBdiDOahtWIFYgmsrluFBkwbsQIz4QyAeFDS7yibr2wh+h2GYDx6PGWNQoQ6RTiNeh85RSAQj4f5Etgo9L3ab0CVUCnkCDKx7bAQv4kYfro/PDcUTrXARjIWj9pHcLWtdK4h3BvhDEtT5bJBwfvTaYBzqijxBb56QIOxN/YI8Q15sdqbbarfB6M/7WjAHpkQwEX9B5QsiAEBh2P693QAAAABJRU5ErkJggg=="
  })))))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(296.008 64.318)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cy)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cz)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.398,
    transform: "translate(-0.335 -0.065)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAIAAAB1kpiRAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABgAAAADdQHfOAAAAp0lEQVQIHWP8//8/Axh8OtDw9+2B/x8P/vnK8PMtA5ukvXj6ARaI3Kv5Dow/DvIoMzAJM3x/zvD7MwNQ04+7YGkg9f/9QQEzBhYehr8/GZhYGVjF7MVSDgB1MgHx58MNHJIgU/7/Y/j1muHLbQaIHEj6w+6Gnw8O/vvD8Ocbw7dHDF/uMAhF7AepBQMmDiUHNjn7H08ZPl1i+HSRgV27nkPRASrJwAAAzQFCbgjYYQwAAAAASUVORK5CYII="
  })))))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(298.579 64.66)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#da)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#db)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.097,
    height: 3.964,
    transform: "translate(-0.074 -0.407)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAIAAABV+fA3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACaADAAQAAAABAAAABwAAAACzugX6AAAAqklEQVQIHT3LTQ7BQBjG8Wf6lQlpG0QQSwsLe9vRcAm3GbdxAZFIMAchBBsbaZvQjrbGlPDs3v8vL1FK4bdozc0KVI6XhD/h5GvpUcSLgLZLSC7IYtgdZumfdC/iZeD2YdeQR5BXOF3mj3lpt3ngDeDUAYIigdlkjanQ3QhX3HJhUBQSzxvuB1SHXIOeFW1mtFXWLMTjDMNjtDf6EEiy28qT0IfKoOsfdHkDPS5AoMnbl0oAAAAASUVORK5CYII="
  })))))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(301.14 64.998)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dc)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dd)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.964,
    transform: "translate(-0.369 -0.178)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAIAAAC+zks0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABwAAAADgIF5+AAAAs0lEQVQIHWP8//8/Awx8PdHw6WAjIwvDn08MPLb1Ai4NjBDpH/cOfNjgyK3AwCbE8PMNw5c7DL/fM8h3/meC6Hw931HAgIFbkYGZGyTAKmkPlAMyQNIvZjjwaTEwsTEA7fn1juHLLQZemwagOBCw/Lh74O/rg/94Gf7+YPj7jeHzTQZui3oOZQewLAMLkPr7k+H7Q4bfbxn+fGVgErTnd2qAyIFIoNOA4Pud/e931YOZKAQAb6NZZQCyYmYAAAAASUVORK5CYII="
  })))))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(303.69 65.328)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#de)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#df)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.097,
    height: 3.964,
    transform: "translate(-0.087 -0.508)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAIAAABV+fA3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACaADAAQAAAABAAAABwAAAACzugX6AAAArUlEQVQIHU3MOw6CQAAE0GH5bWzEQjEUUlB7BqDwBt7A6DXkHtZWnsEAvb2NFpYimiDKR36u2cYp52VG6LoOf0n2HgSopkMtR+BWnIPs4CELiYIyxucO2bAlvnns3P4UiokmR52iq6HNPMIs3jq9CagBIqPNUSUYLXz2SdhbE4XqEE2G6on3BYP5D9hGum5cOkZ5g0hRRGhFmwMzoi99otmvE9IjZGutrwLW8nwBXGI/aPOaUWoAAAAASUVORK5CYII="
  })))))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(306.24 65.651)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dg)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dh)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.964,
    transform: "translate(-0.372 -0.265)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAIAAAC+zks0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABwAAAADgIF5+AAAAsklEQVQIHTXOTQqCQAAF4Df+1CyMXEQZ7orO4Sy6RkvvoefoCB2hhc6uG0RECO0iqMwUTWWaqXzbj/d4RAiBLk8e6BRpFJpTz3SZvQyMjnDbML3hGMJaoEh4secQ+PNlzSyXUweiQXFGk2PiR3TONNl+bINen/dsEA1NhtcBo5UySVp5ivNdSAy0Jd53ZEfoY4/OlMmo8bZCnULUqK7AwHP8WMk3RD6XA2USyyOy9NvsFB8uvEQ3C1fq9QAAAABJRU5ErkJggg=="
  })))))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(308.773 65.967)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#di)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dj)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.097,
    height: 3.398,
    transform: "translate(-0.072 -0.013)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAGCAIAAACepSOSAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACaADAAQAAAABAAAABgAAAACO2ixKAAAAnklEQVQIHT3LMQrCMABG4T8xQiIUhCJSdFFHZ+fmGm5u3sC1epXiPdos7o7ioOJiadWhRdMijVHBt348YozBt2Kz1NsV5XjlqG5gns9+kK2laCtnjLrE4wSTgg/lx7JQMqq4B8LwPKNM0ZlFfCSpPsT1XTVdwKC6Ql/QmgQW7EOOC4g+RA+kAZ2AOL47jS3YaHcelQmKPfId2CD4g7U3UuY1vDLGGvsAAAAASUVORK5CYII="
  })))))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(311.31 66.281)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dk)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dl)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.964,
    transform: "translate(-0.343 -0.327)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAIAAAC+zks0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABwAAAADgIF5+AAAAp0lEQVQIHTXOSwrCMBAG4D9NxUehdqPuPIbbxoXexHPYewiuPUZyEIsutQiitEbNwwm1QyAwXzL/MO89utKltJWkhjewL2SrIu4It4OIvqo3hm1Qn2CeQf582YnRRA3mAMf7Cm+Rii39juiJPkruVH8KPgQcmhLJIhhRRFbtl3Ea8j531GcgyVsLw2kdSjAPaBbyDPLZRhK0xWhzGkAHlOOQrYuOwv0DyKxI0ni7QREAAAAASUVORK5CYII="
  })))))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(313.862 66.587)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dn)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.398,
    transform: "translate(-0.064 -0.066)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAIAAAB1kpiRAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABgAAAADdQHfOAAAApElEQVQIHWP8//8/Axh8OtDw5/WB/x8O/v3B8PMtA6ukvUT6ARaI3Kv5Dsx/D/JqMPwVYvj5nOHXe5Dwj7tg6U/7G9hYD/JoMTBxMDAwMvx8xcAmZS+WcgCoggmo5OupRjZRBkZmhr/fGD5dYWASgcoBpRkflDNwyTJwSDGwcDN8ucPw+yODVCXUNSDd/C71P98wfLnN8PEiw382e6Gw/UBROAAA6N073gnn06EAAAAASUVORK5CYII="
  })))))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(316.438 66.897)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#do)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dp)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.964,
    transform: "translate(-0.374 -0.377)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAIAAAC+zks0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABwAAAADgIF5+AAAArUlEQVQIHWP8//8/AxL4dLCBiZ3h3y8QEnBpYIRLf9zf8Od2I5sIw99vDD/fgND/XwxMEJ0f9zX8vd/IrcrAKcfAKgQSY5ezl+/6D9L94+6BjxsdBc0YWHhAWr/eZ/jzz14k9gBQEUj6cQ0jrxYDpxQDIwvDj+cMX+4wSFVCHcTyYXcDIxvD7w8MjIwMvz8zfH/CIJq4H2Q6GEAN//nwAMN/hv9/GQTcGqAyYAoAdr9OeAmBQDUAAAAASUVORK5CYII="
  }))))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(319.032 67.206)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dq)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dr)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.398,
    transform: "translate(-0.136 -0.118)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAIAAAB1kpiRAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABgAAAADdQHfOAAAAq0lEQVQIHS3NOw6CQAAE0Flco4YYDCYWlthZeAU+J7DzAh5Ej2HLLbRh7YytrZCIlYkaAYElgOtGnGSql8kQIQR+4QGrHyw7rkFQxmgNTc1Z0caKkCVbW52gP0UZoUrBg73mgMg191mys7UZqIq6QB6CR+ZoyeRSkb27dm8MQiEq5Fe8z2hMEr1trLYO8UGVoHwhu0BfeBKaKB3Dkmepj+cB8QmDudc1rD8CX4xDRQAIHoGpAAAAAElFTkSuQmCC"
  })))))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(321.657 67.515)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ds)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dt)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6.23,
    height: 3.964,
    transform: "translate(-0.496 -0.428)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAHCAIAAABRDCAKAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAC6ADAAQAAAABAAAABwAAAABnhpU9AAAAvElEQVQIHU2OPQrCQBCF326CpvAXAum0sLDyDEY8grWl5zD38AreIZvGwiuIiIqghURICEk2Zp01EhyGab7vPYYppfA36VHkN8E4SonmwLVGLquN9CSSvcfLgHARIb2jiOGsfLPKUzTczjoTNPp4ZyhTqALd+Zo6fka889pjWA7AkT/12kufMOW18di4Jg+MFsoMMkJyRW/hN4ca05jUn10C2JAh5AvxAYY9rTEZ+lMtnQUYlAQ1V+XfvD4fjrdQA1uyR0IAAAAASUVORK5CYII="
  })))))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(365.652 73.661)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#du)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.068 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dv)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.097,
    height: 3.964,
    transform: "translate(-0.241 -0.338)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAIAAABV+fA3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACaADAAQAAAABAAAABwAAAACzugX6AAAAqElEQVQIHTWOvw7BUBjFf7cViqURYtPBQxjV4DWMnqObt7GZDG7iNSSEkDBQ/+qi7XUvcZaTnN/58h2htear6zxyPPSbTFEKQq8dCsOeK3me9LwGosj7xGNHeqE5nBXUUsbjXq2DWyW7kyv0ywJz56iFrLRwipCTP0k21AcWmD8Ft0y6J72hc5I1jt/9ActMV20h43VEHQhG0qQ/2S3xNEKAxu9H/9z6B7UOR5RQt7fHAAAAAElFTkSuQmCC"
  })))))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(367.716 74.038)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dw)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dx)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.097,
    height: 3.964,
    transform: "translate(-0.107 -0.148)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAIAAABV+fA3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACaADAAQAAAABAAAABwAAAACzugX6AAAAqUlEQVQIHWP8//8/Axh8Ptzw5WgjCy/Dr/cMLJL2/A4NjBC514sc2NgOckgw/PvF8P0pw5e7DHz29SxAPa/mOrBzHeRWZGDiYPj9keHPFwbx1P3s8g5MP+4d+PvmIKsgAwMjSNPXuwyMvPZACaAelo97Glh4GP58Y2BkYfjzmeHnWwbBoAagBBCwsCs6fD5yECjKxMbw9xuDUOR+DiUHkAzQILg7IXxkEgBS+T0zxbietAAAAABJRU5ErkJggg=="
  })))))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(370.385 74.409)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dy)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dz)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.964,
    transform: "translate(-0.511 -0.518)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAIAAAC+zks0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABwAAAADgIF5+AAAAs0lEQVQIHWP8//8/AxL4cffAzwcH/v9jEHBtAAozwqU/7m/4ebmRTYjh/1+GHy8Zfn9kEEvazwLR+WF3w9/HjbxaDCzcDL/eM/x4wcAub4/Q/bSFUciCgV0YaBzD5xsMP7/aiyUfAEozAfGLGQ4c4gxMLAxAK3++ZvjxnIHPoQEoDgQsQGN/PTnIJMHw4xUD0zuGr/cZGHnsOZQdwLJgpwFd++lgw6/HB4EGcJnVQ9wMkQYAYSxLTP2PUnQAAAAASUVORK5CYII="
  })))))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(373.027 74.773)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ea)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eb)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.964,
    transform: "translate(-0.321 -0.315)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAIAAAC+zks0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABwAAAADgIF5+AAAAsElEQVQIHTWOXQqCUBCFz72KlQ8mFAg9SNAKWoH60DZ6q3W4jBbQAtpBupCCoKKXQgpTNO9thouH+WHm4wwjtNbo9c5TawCauwqDMB4uYmFwfc6KQ+KGkA7aAtWNa7A92sb53CfjJUYzqAZdCVUzI7ck/NjF7hzOBEJCd6jumK6ZEbLrU6ZeufDY0Tb4XiG8yDDGlKrF74PGRnmB9KNgk9HSiF+jAxTCglbwV2mPuP8B0JlH7fqTI5AAAAAASUVORK5CYII="
  })))))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(375.639 75.131)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ec)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ed)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.097,
    height: 3.964,
    transform: "translate(-0.1 -0.106)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAIAAABV+fA3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACaADAAQAAAABAAAABwAAAACzugX6AAAAqElEQVQIHWP8//8/Axh8PtTw5XgjqwDDn68Mv98ziCbsZ4FIPGlg5FFnELZi+Pud4et9hl9vGH7cOwCSezXXgVeDgVuRgYmDAWjKn88MYsn7OZQdmH7cPfD3zUGgUQxMDP9+MXy9w8BlVg+UAOphztV+wPj/IQsPA8M/hu+PGX68ZBCJOgCUAAImdkWH3x8Zvt5l+HiJ4ctNBsGg/RAJIMkIdydcCM4AAE8rPf3V0oZhAAAAAElFTkSuQmCC"
  })))))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(378.225 75.479)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ee)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ef)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.964,
    transform: "translate(-0.421 -0.455)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAIAAAC+zks0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABwAAAADgIF5+AAAAsklEQVQIHWP8//8/AxL4uK+BkYXh/y8GfpcGoDAjXPr1IgemnweZeRj+/2b48Zzh13sG+Y7/TBCdL2Y4sDAd5FZh4FFmYOJk+P+Pgd+5HigFkv5x9wDj94McEgxsggz//zL8/cLAbV4v4NoAlQbaxybKALTy7w+GX+8Yvtxh4HcCyQEBy4fdDb+fHmQSY/j5AqTi4yUGseT9EDkgCXLax70NP+4d+P3kII91PYeyAxDBpQHezERdLuk9nAAAAABJRU5ErkJggg=="
  })))))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(380.8 75.821)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eg)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eh)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.097,
    height: 3.964,
    transform: "translate(-0.164 -0.23)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAIAAABV+fA3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACaADAAQAAAABAAAABwAAAACzugX6AAAAsElEQVQIHWP8//8/Axj8uH/gz8sDnw80/vvNwCJhz+/UwAiReznbgfnfQU4ZBgZGhu/PGL4/Zvj3nYEJqOfH3QOM3w/yaTFwSjOw8jL8/8XAJm0v3/UfJPdmsSO3EgMzN8P/vwxf7zH857AXTzsAFGd6OdOBmYMBaOmfT2DTXjDw2TcAJYCABYiBjvn5guHrHYa/3xiEIvZzKDuAZIBWA90CtA/oSIZ/DAJuDWBBKAEA3INHhgNF43AAAAAASUVORK5CYII="
  }))))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(383.36 76.158)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ei)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ej)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.398,
    transform: "translate(-0.458 0)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAIAAAB1kpiRAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABgAAAADdQHfOAAAApUlEQVQIHTXOQQ7BQAAF0N8xiUksiKQVseIGllbVhIuIe3TcwglcAtHuXUEiJKKhNEjbqeoYhp/81ctPviGlxDdi68VrjtiXBcQJ2QWN8YpqSzfeY+lUOqAtiDNEANa2Ff04nDn1HsomZI5XjJJpWyNPMVE9TvusCUJRCKQBkh20fdbRnD8PPrGQXSFDJHuwrqtAx1DXogW/+xPCkN9QHbi1If8r3i5rQHZB/Gb0AAAAAElFTkSuQmCC"
  }))))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(385.91 76.488)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ek)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#df)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.097,
    height: 3.964,
    transform: "translate(-0.176 -0.33)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAIAAABV+fA3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACaADAAQAAAABAAAABwAAAACzugX6AAAArklEQVQIHTWOQQqCQBiF34xig9mmFkUEQlLXUG/RCTpEq7lMO09QhNNBihYtWmRqIOmUTTNFj5+3eB+P9xOlFP66C265UC+0NTp+RH6sOYk8ibsBCEWT4XFGW4HqTn0Q2Tr25nB9OAMQwJmEw2Vqa1ZsuTcDG4EQyBvqC8YroXOqS6rcU2Y2ZI7qiP4i1UDLLnf8LSEzPAvIK9AL2TQyBDC/FBtOLKgWLIj0fXNjHzoLQ8dISrymAAAAAElFTkSuQmCC"
  })))))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(388.459 76.81)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#em)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#en)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.398,
    transform: "translate(-0.459 -0.085)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAIAAAB1kpiRAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABgAAAADdQHfOAAAApElEQVQIHTXOOw6CQACE4VleIVYYE6Wi8QLGC4DHsNbCY8A9vIS1BRATjWfw0RvQEFkirMC6ZPFvvymGcM7xrzj79BSoJtgL3xyTdahJKu9RtlsMHFhz1G80FWraSc/06FszGEPwFixBnWO8Cs2pp4hJtvdRxIreWZWAXjFadiZIKW9RfgiIiuYDloJeoNmuNMFEXHtsvTaNiQ72hOG49iYSIPsBBv1Cx66xUGcAAAAASUVORK5CYII="
  }))))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.366 116.666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eo)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.076 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ep)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4.531,
    height: 4.531,
    transform: "translate(-0.458 -0.257)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACKADAAQAAAABAAAACAAAAAC2TFloAAAAnUlEQVQIHWP4jwq+39n/flc9UIwBWRwo+qCM4UEFSJCFAQx+3D3w6UDD72cHOaQY/v0CCYEkPuxu+H6hkV2UgdccqJbh6z2YxJcjjYJmDGxCDMycDH++Mvz7AZJgAipnF2Ng5mBgZGH4/4fh2yMGbot6kASHksOfLwy/PjL8esvw5Q7Df3Z7HssGkBagAz7srX/cwPC4nuHjvnq4IwHgZGeiDiteWwAAAABJRU5ErkJggg=="
  })))))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.226 113.966)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eq)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.074 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#er)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3.964,
    height: 5.097,
    transform: "translate(-0.321 -0.392)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJCAIAAABxOqH0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAACQAAAABNrkMNAAAAo0lEQVQIHWP8//8/AxL4cfcAkMeCJMIAFHo1x5FdwZ4RrvbTwYZP+xpZ+Bh+f2QAiX7Y3fD9fCO7CAOHJMPf7wxf7zIwfr+z/91yR35DBnYxBiYWhl/vGb69tmf6ce8AtxIDUCMjM8OfLwzfnzCwSDiwMLIw/P0B4v/9xvDjBQMDpz2ffQPL/98gXX++gkSZhOzF40EuYwDa9qCc4cOeeiADDgBv2VOgAlQfdgAAAABJRU5ErkJggg=="
  })))))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.107 111.3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#es)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.075 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#et)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3.964,
    height: 5.663,
    transform: "translate(-0.199 -0.561)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAKCAIAAAD3rtNaAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAACgAAAAAKDjndAAAAr0lEQVQIHWP4jwq+39kPFGAEYgYk8LCMkd+1ngku8uPugYfljCy8DIwsDCC1QP7b5Y6sAgys/Az//zL8Z7Vn+XH/wLuVjvx6DOyiDEDDfr5gYBB3YPpx+wC3EgOHOAMzJwPDf4Y/XxhYpRyYvhxrZGBi+PsdxP/2gOEfsz2HogMTr239z9cM358yvDvJ8Oe/vXD0AaD9LEBdP58z/GexFwhqAKqCOgnoBojLgQw4AADPS2T5UzxaygAAAABJRU5ErkJggg=="
  })))))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.99 108.654)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eu)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.07 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ev)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3.964,
    height: 5.097,
    transform: "translate(-0.087 -0.182)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJCAIAAABxOqH0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAACQAAAABNrkMNAAAAp0lEQVQIHVXOPQrCQBQE4Nlls8RCJKCImM7CAwi2iffwGtYbL6L3iIWx9wAWBsRug6L4QxLZZH12ZsqPYd6Dbea0AAHHX7J1yCTum0gQFmlSnpN8v+QuWgMwBkGUrWbtMbwprMHnCkgI6nsTyB6cDswDtYE7DLnROybAnR8VGrUI3FEoaKW8oHrDVnil6M4jusQdPyg1ngegr3xlqUiK/Li9xar5tP0C/J5ZtzIZxskAAAAASUVORK5CYII="
  })))))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.879 106.022)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ew)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.077 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ex)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4.531,
    height: 5.097,
    transform: "translate(-0.537 -0.385)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAIAAACAMfp5AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACKADAAQAAAABAAAACQAAAACLLHDYAAAAs0lEQVQIHWWNMQ6CQBREZwUNaCzcxoJOG+Ml2NYDcAEvIvewsvIONrKHMFYYC2MgxhhBYYng+tHExDjVz5u8+dB/uaxmxEz8Jp4LFUprIBpfrnbBeSmQyhYH3bWhwiAJfFZI24E9hjqCMTCaOy2E8ZTdEYw2qgzpFnyq66kyklYfzIR+ID8AHZfg+7lGmUHHKG+478E9n4raqHIUEZIN8qvLvbU1FARro+m4T4bexP8gIpQXeFFV1alhWr0AAAAASUVORK5CYII="
  })))))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.774 103.406)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ey)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.075 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ez)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4.531,
    height: 5.097,
    transform: "translate(-0.433 -0.037)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAIAAACAMfp5AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACKADAAQAAAABAAAACQAAAACLLHDYAAAApElEQVQIHWP4jwre76p/PsMeKMbCgAQ+7G74dLCRkRkkBJX4uL/hy5FGDkkGPi2GX+9gEi9mOLAwHxQ0Y2ATZPj7g+H3B5AE04+7Bxi/HuRRYWAXZWBiZfj3g4FZ2B4sce8AmwjD3+8Mf7+BDPl4lYHbvAEowcLwn+HnayCD4dcbhi93GUTj97MrOID4QJc9qmV4WM4AdCiQDQcgie939sP5cAYAUHFtLjfYQW8AAAAASUVORK5CYII="
  })))))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.677 100.794)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fa)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.071 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fb)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3.964,
    height: 5.097,
    transform: "translate(-0.341 -0.259)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJCAIAAABxOqH0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAACQAAAABNrkMNAAAAoklEQVQIHU2OTQ6CMBSEh4qNUWPAA6iJ8QwsW2/WY7DwJpoIh3DnzxYNJiWKFArWYqJhVvO+zOSNY4xBR3Ir7OV0qbpEt83aND+qzlG2E3jGIGiKL01CjjzuexivUOd4HOCqU/ROYz8AncLpQWegM0Zsd7gAoe3H6t7SUSBcGDQlKonyivoFrZk/566NlCm0BPHYhIvBkrctuywJWXHcW/PXB67/V7NgbbCvAAAAAElFTkSuQmCC"
  })))))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.587 98.191)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fc)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.072)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fd)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3.964,
    height: 5.097,
    transform: "translate(-0.25 -0.49)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJCAIAAABxOqH0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAACQAAAABNrkMNAAAAo0lEQVQIHVWOSwrCMBRFbz+CFlFBEJzowLG4hMRVuBgHdhuie2nqOiyoCFpF0Q7SSJrU14mfA3dyuNz3UP6TbyMSDgU/nJe8PuJf+9qJLAr1KTYKlVWJyDahvcXBENZCJnBo6LKetsYIBvAaUCnUk7lUbE9ALb8JI6EfqPW573iwBayCLpAfYXzW4aFbGug75AHXCOgtujNRfUS7+znSFaOzH97rqWk5Fb+jVQAAAABJRU5ErkJggg=="
  })))))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.504 95.582)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fe)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.073 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ff)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3.964,
    height: 5.097,
    transform: "translate(-0.165 -0.149)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJCAIAAABxOqH0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAACQAAAABNrkMNAAAAp0lEQVQIHWP4jwqeT7f/fmc/EwMSeDXP4ffTgz8fHGAEKgWKfzrQ8PlII5sgAyMbw8/nDCDRFzMcWFkPcogzsPAy/HrHwChZz/JhVwNQiFedgYWH4e9Phn+/GBh/MDA+rmPg12fgkGD4/w+k8PM1BsmK/yxAzu9PIBuBjE9XGURi9wPZTHxO9d+fMny8xPBfoF6m/j+HkgNQlIVdzuH/XwYBlwYgBw4A37tRJKO2ZP0AAAAASUVORK5CYII="
  })))))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.428 92.97)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fg)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.058 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fh)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3.964,
    height: 5.097,
    transform: "translate(-0.105 -0.372)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJCAIAAABxOqH0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAACQAAAABNrkMNAAAApElEQVQIHWP4jwre76oHCrAwIIGf9w983NsIFGCCC37c2/B2hSMrPwMTKwNI7Yc9Dd/PNXLJM/BpM/z+wMDIzMDyYXfDt7ON/HoMHGIM//4w/PvB8O8XA+PjBgZ+XQYOaQZmDpDCD+cYxAv/szAyMjAwMvz7yfDnI8OX+wwCQftBtv37zfDjOcPHCwxfX9nzuuxnl3cA2f9+d/3DKobvd/YjuxsA691XlqWPKS8AAAAASUVORK5CYII="
  })))))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.359 90.372)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fi)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.059 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fj)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3.964,
    height: 5.097,
    transform: "translate(-0.034 -0.041)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJCAIAAABxOqH0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAACQAAAABNrkMNAAAAq0lEQVQIHU2OQQqCQBiF3wyTREqb6gBRQdAhJqF7tOwErfMk4U0coTsEYdY2IwjNtDG134XQt3g/74MHP+o/ssC7bkHJ0ZKf1d21eQ+fixIkqScHp459a4byDdaByEMV7W1zDHPRrPQDVQEWuVJw35pCmNBPJEcMNzX/3nxjACZQxHidYMx3tBCoUGZIg8bWXdmXDlleJEhDaC2tlTdaK1IEo+/odCfLprX8ADA0TvCLn0oSAAAAAElFTkSuQmCC"
  })))))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.298 87.757)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fk)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.059 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fl)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4.531,
    height: 5.097,
    transform: "translate(-0.54 -0.261)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAIAAACAMfp5AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACKADAAQAAAABAAAACQAAAACLLHDYAAAAqUlEQVQIHWP4jwGeT7cHijExoIKXMx1+Pjz44+4BhMSPewferXBg+HaQTZjh54MDLBANL2c7MHw9yCXPwKHJ8PMlw///DIxA417McGBlAYmyizL8+cLw+QaDcArYjv+fDnIrMbAJgTR/f8bAwGUPZICN+sfw9ztI9Pcnhu+PGCRKDgDZIMv//QaZ+/40w7dX9hIl/4EiQADSwSJu/4eBQTCkgUPZASQGBgB9PFI8YE8gawAAAABJRU5ErkJggg=="
  })))))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.241 85.125)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.059 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fn)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4.531,
    height: 5.663,
    transform: "translate(-0.483 -0.463)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAKCAIAAAAGpYjXAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACKADAAQAAAABAAAACgAAAADMjAoIAAAAuklEQVQIHWP4jwG+39kPFGNAE3+/q/5BGUiQESQJAx/3Nnw+3MjAxMBjWc8CEfxx78DbJY7s4gy8mgy/3oLEQDo+7G74ea2RV4OBlZ/h30+GL3cYhJP/MwElP+1v5NNiYBNmYGJj+P+HgYnfHijI9OPuAaAQIxPD/18Mfz4zfL7NwGXSAJRgAZr+/x/Dj5cM/38zfLnHIBq/n13BASgBctmjGoanrQwf9tQD2XAAshxoGlAFh7IDkIQDAL/9fHeQvVUYAAAAAElFTkSuQmCC"
  })))))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.191 82.46)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fo)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.06)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fp)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4.531,
    height: 5.097,
    transform: "translate(-0.432 -0.066)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAIAAACAMfp5AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACKADAAQAAAABAAAACQAAAACLLHDYAAAAqUlEQVQIHWP4jwq+39n/fLo9UIyFAQn8uHvg1VxHBmaQEELizWKHnw8P8qgy/P4AkwAqfLfakV2EQcSe4d93hj9fYRLvVjjyaDBwyTEwsTL8+sXAJmsPlGECKmcVYmATYmBkYvj7neHnKwZOwwagBMvPBweY2Bj+fmP485nh52uGP//t+eUcQBL//zL8esPw+x2QzSAQtJ9DGSQKAkAnPyhneL+zHshABgAqN126KaJbfAAAAABJRU5ErkJggg=="
  })))))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.142 79.778)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fq)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.059 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fr)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4.531,
    height: 5.663,
    transform: "translate(-0.385 -0.219)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAKCAIAAAAGpYjXAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACKADAAQAAAABAAAACgAAAADMjAoIAAAAt0lEQVQIHWP4jwq+39n/fLo9UIyFAQn8uHvg1VxHiAATXPzD7oY3ix3ZRRlYBUBiIB1AhV+ONzB8OShowsDAzPD1Lkzi08EGVpaDXFoMLNwMf74w/PkMkmACKv/39iCXAgMrLwMjE8PX+wy8NvVACZYf9w4ADf37HaTq50sGBi57XtsGkATDf4Z/Pxl+vmD48YKBSchePPUAUBQImDiUHX68Zvj9x14wZD9cFCQD9Mv7XfVAEg0AAIXDZIwWLl4EAAAAAElFTkSuQmCC"
  })))))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.097 77.059)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fs)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.059)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ft)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3.964,
    height: 5.663,
    transform: "translate(-0.339 -0.334)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAKCAIAAAD3rtNaAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAACgAAAAAKDjndAAAArUlEQVQIHV2OSw6CQBBEawZiYiJs4Ap+lp5AZuUdPI0cA3feBOYSrkRdmAAhJESijAiOHaPEWKuu6tfpYlpr/EjFETn2l2YboQ6S9xxR+VZ0hTSGX5Z8c5bWBOC4xu80DYTxlNYUpo1HCVV5nA7bTFozDBwwjraC4QqujtFoDGaiU1AJLjvYC5/Tvqtxz3E7oS49ZxXSf1O3UCmaAsP52l36n0rUNwm8eh/S0OsFt/Vc9lea8nwAAAAASUVORK5CYII="
  })))))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.618 147.508)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fu)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.058 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fv)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 5.663,
    transform: "translate(-0.162 -0.487)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAIAAAACUFjqAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAACgAAAAAYsJrPAAAA8ElEQVQYGWVNy07CUBA9bS9QwQYwIWGjCZq48xe0DXyPS7fghm9gQ+IvuHWh8B9o0JhUMUbKq723t73MSGTjZDJz5pyZMzD/Ip487Tns0Q6QNr3Bx+BqN9r4i+RlFD32ZsNAeJBv4+R5RIpFW4Rmd4HbhKigWIeKkP5AfuKkbwRp0X3gnaN4hFIDMBCHUGXoJds61xfTQuW1fIxCDU4J+P2WK2Rr3rDV+9hyYDQnsXnCqdd86p76IpfQK6QHyDVfmwzpAlnMpHvm29VON51DfUOGSELEIeQXj9mGDUS13aNG/vOHW6qWYAPvsltv+cRvAefWmJplcvYvAAAAAElFTkSuQmCC"
  })))))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.953 144.81)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fw)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.197 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fx)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4.531,
    height: 5.097,
    transform: "translate(-0.358 -0.057)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAIAAACAMfp5AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACKADAAQAAAABAAAACQAAAACLLHDYAAAAtUlEQVQIHWP4jwq+39n/oJQBKMYIxAww8OPugVdzHBnZGHht6lkggh/3Nnza38glz8Cnw/D7IwMjCwNI4sPuhu/nG4WtGVh4gYYwML1k+PeHAWTUkwZGfj0GTlkGJlaGP18YPpxjEMv7D9LBzMXAxM7w7xfDvx8MX+4xMPLZAwVZPuxqYGRm+PmW4fcHhl9vGBgF7EUTDgAlQEY9qmIEamIWsRdwbeBQdgCKggBQ4v2ueiCJBgCzh2UU6d9ZDgAAAABJRU5ErkJggg=="
  })))))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.955 142.144)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fy)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.075)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fz)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4.531,
    height: 5.097,
    transform: "translate(-0.481 -0.224)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAIAAACAMfp5AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACKADAAQAAAABAAAACQAAAACLLHDYAAAAq0lEQVQIHWP4jwq+39n/fLo9UIyFAQn8uHvg5SxHRmaQEFTix70DX080/Lh7kFuZ4c8XBqAKRqCuD7sbflxq5JBg4JRm+Peb4es9BpF0sFFfjjYKWzOwCTIwsTH8fA2SAxkF1MUuygA0998fhj9fGX68ZODQrYfa8fc7iM/CzfDzJcNfZnsx+waQBIeyw+9PDP//MPz+zMDnUC/sChIFApDlQNOALKAKIAkHACQ9WUSBVUGwAAAAAElFTkSuQmCC"
  })))))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.837 139.497)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ga)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.071)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gb)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3.964,
    height: 5.097,
    transform: "translate(-0.368 -0.412)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJCAIAAABxOqH0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAACQAAAABNrkMNAAAAn0lEQVQIHWP8//8/AxL4cfcAkMeIJvpypsOPewdZ4Oo+HWj4uK+RmZOBmQOsFqjr/VpHNiEGDnGGv78ZfjxmAKl9t9yRV5OBU5aBiZXh9yeGr3cYmAtsGJgZDnJKMQD1/v/L8O0hA6duPQvDP4b/fxh+f2b4+5Ph+1MGRh57HusGkAm/3jL8/gBSyGVaz+/UALIf6LIH5QwfdtcDGXAAANDqTKp8aJocAAAAAElFTkSuQmCC"
  })))))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.727 136.865)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gc)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.077)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gd)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3.964,
    height: 5.097,
    transform: "translate(-0.251 -0.048)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJCAIAAABxOqH0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAACQAAAABNrkMNAAAApElEQVQIHWP8//8/AxJ4McOBQ9mBES764+6BTwcbfj0++O8XA0gUyn90kE+b4c8Xhh/PwaKPaxj5DRk4xBiYuRh+vmb4/t6e6cOuBl4NBg5JBhZehv//GP58YmCTcWBiZGYAWvfvB8PfbwzfnzB8uc3Aa9vAxMDI8Psdw8+XDB/OMfz6Zi8UuR/kou939j+qYXg51x7IANoMAQxA6v2ueigPRgEAgTpnPnL8RWcAAAAASUVORK5CYII="
  })))))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.622 134.249)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ge)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.075 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gf)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3.964,
    height: 5.097,
    transform: "translate(-0.149 -0.267)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJCAIAAABxOqH0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAACQAAAABNrkMNAAAAqElEQVQIHWP4jwqeT7f/fmc/EwMSeDHD4dejgz/uH4CK/rx/4NUch3/vD3JIMzCzM7AAlQKVsDAe5JFjYFRg+P2WgYmNgeXDrgZWloO8Ggws3Az/fjP8+cTw9xsD45NmBj5tBg4Jhv//GH6/Z/h6n0Es9z/L/78Mf74y/HgGUvj9GYNA4H6gmUxssvbfHzN8vMTAKF4vUfSfQ9EBKMoAdN2LGfaojv4PAPpMXNxyI3Z3AAAAAElFTkSuQmCC"
  })))))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.524 131.639)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gg)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.07 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gh)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3.964,
    height: 5.097,
    transform: "translate(-0.055 -0.491)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJCAIAAABxOqH0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAACQAAAABNrkMNAAAAoUlEQVQIHWP4jwre76oHCjAgC36/s/9BGQOQZGKAgQ+7G96ucGTmZvj58AALUPDDnoZvJxu55Bh4VBj+fgOpYgEq+Xa2kd+IgUOU4d9vhm+PGBj+MzA+aWTg02bglGVgYmf4/YHhwzkG8cL/LIysDED05wvD/w8MX+4xcBrVg0z495Phx0uGfw8Zfr9jEI7Zz6HsADL4/e76R9UMEGfCXQkAsMhl5Ks8JXQAAAAASUVORK5CYII="
  })))))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.434 129.035)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gi)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.071)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gj)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4.531,
    height: 5.097,
    transform: "translate(-0.531 -0.155)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAIAAACAMfp5AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACKADAAQAAAABAAAACQAAAACLLHDYAAAAr0lEQVQIHVXNUQoBURTG8f8dY5qUoUx5VZ482oBhBbZhA/JoVqKsBGUNSlHkjXmgKYOZcZ2bRvnq1O13ut9B/yfZLQ5jxJQMRR775WU+EPB6U/uLQvE6zKNVpUWegMIsRM+zQbVDtYt+84qkClN1nCi/h+NTcklvxBv8kbbkh9NAlUGTxcRbnM5U0FS9n6RXshv3E1Yt8IKwWKTcD9jNoD4M3XZfVGJuyHF5/cgwfABILVgUCvioKwAAAABJRU5ErkJggg=="
  })))))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.351 126.425)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gk)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.073 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gl)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4.531,
    height: 5.097,
    transform: "translate(-0.446 -0.379)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAIAAACAMfp5AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACKADAAQAAAABAAAACQAAAACLLHDYAAAArUlEQVQIHWP4jwG+39kPFGNAE38+w/5BOUiQiQEGfj448GquA8Png6z8DD/uHmABigOpr6cagEIcQgwsUgxfHzBwKDuAJD7saWDnOsipxsDGz/DnG8O/XyBDmIDK/70+yCnDwMrD8O8Pw7dHDDzm9WCJewfYRBn+fmP49YHhyy2Gbw8YuC0aQBIcSg6/PzB8u8/w/iTDj8/2UpX/gaIgAHTZi1n2z6fbQ5wPdz0ARZp5FwSkCRgAAAAASUVORK5CYII="
  })))))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.276 123.814)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.057 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gn)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4.531,
    height: 5.097,
    transform: "translate(-0.387 -0.035)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAIAAACAMfp5AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACKADAAQAAAABAAAACQAAAACLLHDYAAAAq0lEQVQIHWP4jwre76p/Pt0eKMbCgAQ+7W/4fKjx/3+QEFTiw56Gr8ca2cUZeFQZfr2BSbyY4cD46yCvFgOHOMO/Pwx/PoEkmH7cPfDn5UE+TQZuJQYWHoa/3xiYRe3BEvcOcCsyMLEx/PvF8Osdw7eHDFymDUAJFob/IKFvjxiY2Rk+32QQid3PruAA0sGh7PD9OcP3Rwz/BOqla/9DRIESDEAnA90OJNEAAHl3Ytv/ylbuAAAAAElFTkSuQmCC"
  })))))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.207 121.214)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#go)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.058 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gp)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3.964,
    height: 5.097,
    transform: "translate(-0.317 -0.27)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJCAIAAABxOqH0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAACQAAAABNrkMNAAAAnElEQVQIHWP8//8/AxL4sLsByGNEFv1x98DL2Y4MjEiiQFU/LzcCNf79BhYFKnm/1pFdjIFLluH3Z4avd8CiT+oZedQZuJUZmFgYfr1n+P7GnrnAioGV7SC3IgMLJ8OfrwxfbjPwOCxgAZoNBH+/M/z5wvDjKcM/Znt2eQcWhv8gXb8/giwRDNnPoewAUvX9zv6HFQwfdtcDnQgHAK2IU1/ZZvHiAAAAAElFTkSuQmCC"
  })))))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.145 118.599)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gq)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.058)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gr)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3.964,
    height: 5.663,
    transform: "translate(-0.255 -0.49)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAKCAIAAAD3rtNaAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAACgAAAAAKDjndAAAAq0lEQVQIHVWNTQrCMBCFX9qKKWJVqAgudeclkq2H8CzmGAqepAtt7qHLQiuKFpS26Z8JLqwfzMD7eMyg/Sc7n7QgetAh3nO64D+bX8L0KKpENjmcb+964CqS3gq1izyC6cY77k4kncEeoLhBvZn1DIRVSTpHb4xGoX7B9rkFgv7UnKkzqDvKinlcOGhRpiA2ihhkxPxNqBuOyQlayoZrQZdcK4P+9gi2enf5AIi1ZaFw4wR2AAAAAElFTkSuQmCC"
  })))))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.089 115.967)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gs)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.06 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gt)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3.964,
    height: 5.097,
    transform: "translate(-0.197 -0.125)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJCAIAAABxOqH0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAACQAAAABNrkMNAAAApklEQVQIHWP4jwqeT7f/fmc/I1CQAQZeznb4+eggu7w9VPTH/QNfjjT8fX2QiYPh52sGkChQCcO3g1wyDKxCDL/eMjDL1bP8uHvg/6eDfDoM7CIgg35/YPj7jYEJKMopzcDKBxL6+Zbh+xMGPocGpi/HGhmZGf58Yfh0jeHzNQY+n/1AaSZWafvvjxneHmP4y2gvXvCfQ9EBpAvougdlDN/v7Ud2NwAxcGPlPQMHygAAAABJRU5ErkJggg=="
  })))))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.039 113.306)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gu)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.059 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gv)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3.964,
    height: 5.663,
    transform: "translate(-0.148 -0.299)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAKCAIAAAD3rtNaAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAACgAAAAAKDjndAAAAtUlEQVQIHWP8//8/AxL4sLuBQ8mBBUmE4cfdAx/3NDK4MDDBRT/ubXi9wJFNhIGJnQGk9seDA+9XObIJMwhZMPx6x8DIxMAC1PV2uSO/LgO7GEjb/98Mf38xMAFF+bRBQsycDP9+Mfx4wcDv1MD0/ULj/38M/34z/PnC8OUuA5tmPVAHy9+vDL/eMvx6w/D7PYNg6H4OZQegKBOvXf33pwx//ttLVvyHCAFFGYC++H5nP5BEBgASaFUlWGGVfgAAAABJRU5ErkJggg=="
  })))))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.991 110.619)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gw)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.058 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gx)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3.964,
    height: 5.663,
    transform: "translate(-0.101 -0.446)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAKCAIAAAD3rtNaAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAACgAAAAAKDjndAAAArUlEQVQIHWP4jwq+39kPFGBAFgQKPShjeL+rnokBBn7cPfBmkSMLLwMjCwMLUBDI/3SggeHbQW5lkBImoChQ6OVsR14NBm49BkYmhh8vwBJAUT4tBh4VBlZBoDKG3x8YeG0bmL6fb2QVYGBkZfjzieHrA4Z/bPZAxSz/fzP8+cLw7xfDz1cMDNz2ovEHQKJ/fzB8f8Lw9yuDSNx+DmUHoBAIfL+7//l0e2RXA9kAftlphiFaqqUAAAAASUVORK5CYII="
  })))))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.944 107.905)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gy)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.06 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gz)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3.964,
    height: 5.097,
    transform: "translate(-0.052 0)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJCAIAAABxOqH0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAB6ADAAQAAAABAAAACQAAAABNrkMNAAAArElEQVQIHU3LsQ7BUBgF4NPb61Y7iJJIVzF6BEP7DGLzEhaz9j0sHkRcMZhsRsIkGolEBbdSvf4SiTOc4Ts50H95bGb7IagZflFbeV2EzEG6k/yLl2l4X0WiCtsDs1BoPA64nlfaYALPM3QOc9CBPk2IRK24qQPcrmS3ZeQ0YTqAhooB26eNGyXoDOqILEFu+fW+JGVEaYxkDcMb0ZeIwnnDfxlwe2G5FXykqDfPaETCi6eBewAAAABJRU5ErkJggg=="
  })))))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(324.78 68.019)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ha)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.067 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hb)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4.531,
    height: 3.964,
    transform: "translate(-0.152 -0.365)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAIAAAC6O5sJAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACKADAAQAAAABAAAABwAAAAA0HM65AAAAoElEQVQIHS2OzQ7BQACEZ7dpFIn2LJy8gKtTNRKvZT2Ui0SEeABX4eKCpEJXSbs/dm0bc/wmmW+ItRZ1XlvmNWAUjEA4YcQVfMXkYR50AQORQtyhOUhxWvNFEg3hd6BzvI9QJg4TRvMda/XhNQGLMkV5g6PBYEzleeMk3w/kE+qB9mjmqJNSvxeLK4oLsj2UrkbqK6jk2ZIRCmsQTf/UdT/iw0fDkGUjsAAAAABJRU5ErkJggg=="
  })))))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.845 68.397)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hc)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hd)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.097,
    height: 3.964,
    transform: "translate(-0.019 -0.176)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAIAAABV+fA3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACaADAAQAAAABAAAABwAAAACzugX6AAAAn0lEQVQIHWP8//8/Axh8Ptrw9UQjEzvD73cMLJL2/E4NjEC5H3cPfFjvyCnHwC7K8Pcbw7cHDN+fM7DJ2LMA9XzY3cApzcCjxMDIzPCbkeHfbwaxxP0cyg5MQE1Mvw6yCoLMBYp+e8jAoVsPlAByGR9WMQA1ARELL8OPlyADpSqhLmBhk7X//fYg0BpGJobfHxlE4vaDTAADkFtgbHQaAOk+OuQAJk5OAAAAAElFTkSuQmCC"
  })))))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(329.514 68.768)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#he)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hf)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.964,
    transform: "translate(-0.422 -0.547)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAIAAAC+zks0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABwAAAADgIF5+AAAArUlEQVQIHWXOTQqCUBQF4KNpKEQIQX/Dxo3cgE1aSdA2fK6kdWSBPpq2hMBhokaGVIra69obduDeC+ebXIi/3H33fQlkrdDBL8WJvc6eOUddoEpQPzDZBpq0dLdSaj5comdAyVDGMBYOUcdlFLY3btnojyA+EDH0mTPehEQqTb5nxhSqDtGivOIZQRqRlh9Yk/BGRZUBCaoUpu0SyHSv5UdWcE8bdA2ZtWbSaH8B5Jda0N5lGa0AAAAASUVORK5CYII="
  })))))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(332.156 69.133)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hg)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hh)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.097,
    height: 3.964,
    transform: "translate(-0.232 -0.345)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAIAAABV+fA3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACaADAAQAAAABAAAABwAAAACzugX6AAAArElEQVQIHTWOPQrCQBCF32ZXMRpQSBEFG9Ez2IYgnsUjWLrHsfICFm4OotiIjUETkWxi1nXiz2OKYT6+4TFrLf7JYsld2AomR3cm2ZcVR3XdRO4QvIkigT6jyuCQo/cqWUfeBJ0RGn79RARhsNgJ2m5b6Y3R6oMJmAfKCwZLRXeHJJvG4HiVqO7IT2hPVwQoQh+U0ahS5M/aMDz0I/lBqLuQSsMcUOXe/AcIvwHuFEiqJVbtkgAAAABJRU5ErkJggg=="
  })))))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(334.767 69.489)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hi)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hj)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.097,
    height: 3.964,
    transform: "translate(-0.011 -0.133)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAIAAABV+fA3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACaADAAQAAAABAAAABwAAAACzugX6AAAAqElEQVQIHWP8//8/Axh8PtTw7XwjIyPDn28MzCL2/I4NLEDxH3cPfNjgyCnFwK/P8O87w5c7DD/uHWRwZADJfT7awCnDwKPMwMjC8OMHw79fDGLJ+zmUHZiAmv5/OMjKz8DACBL99oCB07AeKAHUw/iwioFTmoFDmoGVh+H7M4a/jPYiMQeAEkDAwiZr//vtwX8/GP5+Y2ASsRdwbQCLgwhGuDvhQnAGAAxhOZjiYXEBAAAAAElFTkSuQmCC"
  }))))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(337.353 69.836)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hk)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hl)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.964,
    transform: "translate(-0.332 -0.481)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAIAAAC+zks0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABwAAAADgIF5+AAAAsUlEQVQIHWP8//8/AxL4uLeBkZnh328GAdcGoDAjXPr1QgdW5oMMTCC5H08Zfn9iEE/dzwLR+XqBAyv7QU5JBiZ2hm+PGf79ZOB3rudQdgBJ/7h7gPH7QS4VBhZekKY/nxlEEvZzKDoApZiA+M0SR1ZBBob/DH++MPx8xfCXwR4iB5L+sLuBkQUk8eMlw7eHDB/OMfA5NgAloADotA976h+UMTzrZPi4r/77nf1AETgAAE7pUdY+IfjuAAAAAElFTkSuQmCC"
  })))))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(339.923 70.181)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hn)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.097,
    height: 3.964,
    transform: "translate(-0.07 -0.259)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAIAAABV+fA3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACaADAAQAAAABAAAABwAAAACzugX6AAAArElEQVQIHWP8//8/Axj8uH/g39sDPx8e+HbtII9VPbuCAyNE7tVcBxbmg2xCIFXfnzH8eMrw7ycDE5DzYXcDC+NBbiUGThkGVj6Gf98YWKXt5bv+g+R+XGzklGZg4WH4/xekiZHfXiLjAFCc6cUMB2Yuhn9/GP58Yfj+hOHLLQaxZJAEELAwMjP8+cjw/TFQGUhONGE/RAJIgtzy4+6Bn/cP/P/HIODWAJcAMgACPEWeJZUyjgAAAABJRU5ErkJggg=="
  })))))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(342.487 70.517)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ho)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dd)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.398,
    transform: "translate(-0.367 -0.028)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAIAAAB1kpiRAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABgAAAADdQHfOAAAApElEQVQIHWP8//8/Axj8fHjg3UpHDnGGf38Yfr5gYBKxF3BpYILIfTrY8HmXo5A5A7cSAysfA1AHI1iCEaj7x90DH9Y7ClkwsPAx/P3K8Pkawx8Ge7HkA0AFIN0fdjdwSIAU///D8Osdw/enDBA5oAgLUO7Py4P/2Bn+fGH48Zzh6wMG4ej9ILVgADL81TyHX48OsvAw/HzNIJ62n0PZASrJwAAAKfBBLK7Jza0AAAAASUVORK5CYII="
  }))))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(345.038 70.847)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hq)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hr)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.097,
    height: 3.964,
    transform: "translate(-0.086 -0.358)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAIAAABV+fA3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACaADAAQAAAABAAAABwAAAACzugX6AAAAsElEQVQIHT2OQQ7BQBSG/45mUjSxUAkRsWDhAKzbxiXcxqydwCkkLkC7dQIbCZFIY0MrVZOOjofw79735b33G1pr/JKsRamMQqGQqI2F8XXyEFwXvtUC45BnZBGKOxjtPHZBvPTtAew+uAOtwNtud6ZNculGlDuwmjCAZwrmuI1JQJxFc09FIZ1SN2QnJFtUR4IExZT7kNeRX5DHyI6oDKdWz/sovLvEK0EDvSH6F0RecflCoCPZ7+EAAAAASUVORK5CYII="
  })))))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.589 71.17)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hs)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ht)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.398,
    transform: "translate(-0.372 -0.115)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAIAAAB1kpiRAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABgAAAADdQHfOAAAApklEQVQIHWP8//8/Axj8uHvg77sD3041MjAy/P7EwCxsz+/UwAKX+7DZkVeVgU+L4ddHhr/fGH7cOcjvxMAI0f20mVHUiYGFi+HvL4bvDxl+fLYXSz4A1MkExC9mOPCogEz594fh93uGrw8Y+BwaQHwGBhaQla8P/uNi+POFAWjr5xsM3Ob1HMoOYFkGkN1/vzP8eMbw6w3D748MPDb1fPYNEDkgCQA1A0Ikh0oZ0QAAAABJRU5ErkJggg=="
  })))))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(350.121 71.487)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hu)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hv)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.097,
    height: 3.964,
    transform: "translate(-0.072 -0.431)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAIAAABV+fA3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACaADAAQAAAABAAAABwAAAACzugX6AAAAr0lEQVQIHTXNPQ6CQBAF4Aca0AqNiVYUVpYeQU30Bt7Ba6yexxNYyNJ4AWOnoSExIVFBISx/O7ISp5jme/NGIyL8R9x4ceckQTmsJdMaEx7PLoxCV+9ABMgfqD5o1zd1/LVfWFMYE5SxAiow2jjK4hPr2jCHqrpKUL5h79QjPTyw6ukaA0iBLEDiob92VKq26LiFVD2pj+gMMmfmeP4jaOnVyX0uc2gtUIXeijVQ7y8Iq1Flne0cTwAAAABJRU5ErkJggg=="
  })))))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(352.657 71.799)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hw)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hx)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.964,
    transform: "translate(-0.342 -0.176)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAIAAAC+zks0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABwAAAADgIF5+AAAArUlEQVQIHWP8//8/Awx8Odbw+9mBnw8P/v3OwCJmz+/cwAKR+nH3wIf1jtxKDJzCDKysDF8fMvy4f5CfgQEq/WF3g4AhA5sQw7/fDL/fMfz9yiCesp9D2YEJqBsox8l/kImDAWjNn68MX+8zCIWB5IBSTEBjv55sBJoC1PHrNcPHiwzMwvYQOaA0yPB/Pxh+PgPJ/XzJwCJpL5p4ACgIAYwQlwPNAPLhmqCSDAwASw9Ep7jLXdYAAAAASUVORK5CYII="
  })))))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(355.212 72.106)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hy)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hz)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.964,
    transform: "translate(-0.065 -0.483)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAIAAAC+zks0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABwAAAADgIF5+AAAAsElEQVQIHU3LMQrCMBgF4JdYajpZlFrQwcHNxSO0IJ7DRc/g2I7eQ68hbU7hJIibtFZE1JiSxpSC+Kaf9/2PaK3xl/s+Ji1UJdx5bGry43wb0pJThvKGTwH1xGijrWaZ70Kny+0elKgLcUFnFpmjZrOzKHeG0BVkAZnBWyRsHBqi4piqjLc9qDfkFa8z7EnUmGFyWoMNwPogtDbiBv4yNdCE+qsELHgcIEXAptG/mY8vhgJAKnO/hNYAAAAASUVORK5CYII="
  })))))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(357.783 72.416)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ia)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ib)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.964,
    transform: "translate(-0.371 -0.227)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAIAAAC+zks0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABwAAAADgIF5+AAAAsElEQVQIHWP8//8/Awz8fHjg37sDH3Y1/vvJwCJpz+/UwAiXfrfGgennQQ5Jhr/fGb49ZPj+jIFNxp4FovPVHAd23oM8GiAeUCsQiSXu51B2YALyf9w98P/rQU5pBkYmhr/fGL7cYeDQrwfKAaUYv9/Z/3a5I7ciA9DY/38ZvtxlYOSyF4k7AJQDApDhQKN+vGT4/Ynhz0cGRgF7CZgcUArqtA+7GxgYGQRcGoBCyAAA1odGQ95oZTYAAAAASUVORK5CYII="
  })))))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(360.377 72.725)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5.663,
    height: 3.964,
    transform: "translate(-0.132 -0.535)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAIAAAC+zks0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAACqADAAQAAAABAAAABwAAAADgIF5+AAAAsElEQVQIHWP4jwHe767/fnc/RJgRSDGAwadDDT8uNnJIMvz5wvDjBcPvTwziyftZIHKvFzgwMx4UMGL4/5fh/z8GRiYGDnl7oBRI+sfdAwxfD/IaMrDwMvx6z/DvGwOLmL1owgGgFBNQ7s0iR3ZxIBNk4PcnDL//QuVA0i9nObIKMvz7xfDzFcO3hwwfLzHwOTYAJSCA8fud/Z8ONvx6cpDhHwOPdT2HkgOHsgNMlgEAMQ1cUR15vsQAAAAASUVORK5CYII="
  })))))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(363.003 73.033)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ie)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#if)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6.23,
    height: 3.964,
    transform: "translate(-0.492 -0.276)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAHCAIAAABRDCAKAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAC6ADAAQAAAABAAAABwAAAABnhpU9AAAAtUlEQVQIHU2OTQqCQBiG36mpZiFhEOiiTUSbLpEu6hgtu0Zzo/YFqVAnaFsURnvFzDR1GlGGvtUHz/tHhBD4u+jI2wyfq0sNq/xCX3CqaHp3o53NTIgWSIro5OVRBUmdIU2xa2tTUA1FjNcFWTqXAWxiVQqJg63dn6FnghCEZ8Q3jDZNO5U4PPDOAISiSJA88PYxXDmqvdqR+V7ehchRZkieMNYOG1tK0ewI9lzmixL6kitWPz8s7VDYxr4+zwAAAABJRU5ErkJggg=="
  })))))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(277.744 59.117)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ig)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.282 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ih)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19.255,
    height: 9.628,
    transform: "translate(-0.481 -0.533)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAARCAIAAAA3y+mWAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAIqADAAQAAAABAAAAEQAAAADHM0E4AAACDUlEQVQ4EaXUi20iQRAE0ONnyMgyadiJWJAGnzxs0gDkhCwbDPeW4tprxCGdriSamp7uqpnZ2e0cj8df/4LZbFblk8mk+G3SuWGzXq83m43+xWLR6/W63S7e6XTE/X7f7/c/Pz9xCvDw8DAej/9mfN3GkpfLJUUgd3d3NxgMcHKJCFdxt9txgo+Pj68T7u/vmbFMPvHSJgZ0gaJNsAGcLmijDuk/HA52ZojYHCPGcGH2bcPA4VC08OFwyCYHJQIbIC0STYx6IhvqsXx/fw9/fn6eTqdNlyJ/j4+Pb29vpMuAmbWTO+3h/FQMQb2uAoMghyYyA5uDl5cXB9j0e9Tb7ZbuaDSKeh2OWaBYhGIZXCVVaUGO4enpSabv5zoZk263kUsmJM0VU2nYbslse0pvko1NG4rMnc6mOU8wW7FOTDISp5ImOCtRMiT51Cv+tlEBJlIR9WRyBWSC2qVhDEifuhuPEPFPefN/tsmc66EtDyYNeK0opNYRoRJNvVgwhb++vrL5cdNIuNCkLT/AQV6s1bWdCJHLnqLbNvZpWK1W3zaYK+G+nWSbEL8MzXKlFSecOp6Fy0PUZfDE8lB53k36vaGQtddutOH85JUZ4iJc2MjEjMHF9+aHTcy8RvP5PLc8GdGbGw9a2VlsIm2KpUg931C8jSs2NW1neGJ2kKk8m3A29VUuUgpFbtlU0f+T34SCmhaMKvc8AAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(323.324 330.206)",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ij)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ik)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 79.051,
    height: 112.087,
    transform: "translate(-1.171 -0.829)",
    xlinkHref: "data:image/png;base64,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"
  })))))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(392.388 427.565)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#il)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.179,
    height: 15.579,
    transform: "translate(-5.242 2.547) rotate(-25.899)",
    fill: "url(#im)"
  })))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(385.719 417.359)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#in)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.392,
    height: 16.978,
    transform: "matrix(0.896, -0.445, 0.445, 0.896, -5.213, 2.591)",
    fill: "url(#io)"
  })))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(361.969 370.518)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#ip)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.134,
    height: 53.226,
    transform: "translate(-17.884 8.878) rotate(-26.411)",
    fill: "url(#iq)"
  })))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(380.373 407.607)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#ir)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.82,
    height: 18.918,
    transform: "matrix(0.896, -0.445, 0.445, 0.896, -5.647, 2.801)",
    fill: "url(#is)"
  })))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.819 426.43)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#it)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.438,
    height: 7.254,
    transform: "translate(-1.809 0.898) rotate(-26.41)",
    fill: "url(#iu)"
  })))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(332.973 311.286)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iv)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.848,
    height: 76.525,
    transform: "matrix(0.896, -0.445, 0.445, 0.896, -26.286, 12.996)",
    fill: "url(#iw)"
  })))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(330.872 306.421)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ix)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.794,
    height: 15.928,
    transform: "matrix(0.845, -0.535, 0.535, 0.845, -5.288, 3.349)",
    fill: "url(#iy)"
  })))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(359.945 368.566)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#iz)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.459,
    height: 13.481,
    transform: "matrix(0.896, -0.445, 0.445, 0.896, -3.421, 1.692)",
    fill: "url(#ja)"
  })))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(336.04 314.147)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jb)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.816,
    height: 25.92,
    transform: "translate(-9.042 4.417) rotate(-26.391)",
    fill: "url(#jc)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.148)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#je)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jf)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 342.159,
    height: 324.461,
    transform: "translate(0 -1.105)",
    xlinkHref: "data:image/png;base64,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"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.a68b932ae86307429e66149457883571.svg";
export { ForwardRef as ReactComponent };